<div class="w-100 h-100 map-svg-container">
    <svg
        style="width: 100%; height: 100%"
        #svgElement
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2360 1280"
    >
        <defs>
            <style>
              .cls-1 {
                fill: #efefef;
              }

              .cls-2,
              .cls-8 {
                fill: #c6c6c6;
              }

              .cls-3 {
                fill: #e5e5e5;
              }

              .cls-4 {
                fill: #04a2ac;
              }

              .cls-5 {
                fill: #fff;
              }

              .cls-6,
              .cls-7 {
                fill: #b3b3b3;
              }

              .cls-6 {
                opacity: 0.5;
              }

              .cls-6,
              .cls-8 {
                isolation: isolate;
              }

              .cls-8 {
                opacity: 0.4;
              }
            </style>
        </defs>
        <g #svgGElement id="Floor-2">
            <polygon
                id="wall_outside"
                data-name="wall outside"
                class="cls-2"
                points="2314.26 1135.97 93.56 1217.77 53.76 111.77 46.26 105.27 80.66 66.57 87.66 73.57 2238.96 73.57 2250.06 62.47 2287.46 99.87 2279.76 107.57 2314.26 1135.97"
            />
            <polygon
                id="floor"
                class="cls-3"
                points="2295.26 1096.77 109.26 1166.77 68.26 92.77 2264.26 92.77 2295.26 1096.77"
            />
            <path
                id="ebtrance_bg"
                data-name="ebtrance bg"
                class="cls-4"
                d="M1104.67,840l60.89-60.88.7,31.3L1105,871.77Zm60.59-75.85-.37-16.53-60.48,58.59.16,18.63Zm-97.9,360.42a107.07,107.07,0,0,0,103.48-109.38l-4.33-194.82-61.44,61.44,1.09,125.71a35.72,35.72,0,0,1-34.53,36.51l-316,10.51V1135Z"
            />
            <path
                id="entrance"
                class="cls-5"
                d="M852.39,1096.77l.2,7-20.3.5-.8-26.5,20.3-.5.2,7-12.2.3.1,2.6,11.9-.3.2,7-11.9.3.1,2.9Zm20.5-20.1.3,12.6-9.6-12.4-8.3.2.7,26.7,8.1-.2-.3-13.5,10.1,13.3,7.8-.2-.7-26.7Zm33.4-.8-22.4.6.2,7,7.2-.2.5,19.7,8.1-.2-.5-19.7,7.1-.2Zm22.4,16.6,5.1,9.3-9.2.2-3.9-8.2-2.9.1.2,8.4-8.1.2-.7-26.7,14.3-.4c6.3-.2,9.7,3.9,9.8,8.9A8.71,8.71,0,0,1,928.69,1092.47Zm-3.6-8c0-1.5-1.3-2.1-2.7-2l-4.9.1.1,4.2,4.9-.1C923.89,1086.67,925.09,1086,925.09,1084.47Zm28.5-10,10.5,26.5-9.2.2-1-3-9.6.3-.9,3.1-9.2.2,9.2-27Zm-2.1,16.7-2.9-8.5-2.4,8.6Zm30.9-17.4.3,12.7-9.6-12.4-8.3.2.7,26.7,8.1-.2-.3-13.5,10.1,13.2,7.8-.2-.7-26.7Zm26.1,19.4a6.71,6.71,0,0,1-.3-13.4,5.88,5.88,0,0,1,5.3,3.8l6.9-3.4a12.35,12.35,0,0,0-12.3-7.5c-8.3.2-14.5,5.9-14.3,14.2s6.7,13.7,14.9,13.4a12.56,12.56,0,0,0,11.9-8.1l-7-3A5.56,5.56,0,0,1,1008.49,1093.17Zm35.2-1.4-12.2.3-.1-2.9,11.9-.3-.2-7-11.9.3-.1-2.6,12.2-.3-.2-7-20.3.5.8,26.5,20.3-.5Z"
            />
            <path
                id="islands"
                class="cls-6"
                d="M238.46,437.27V327.07a29.38,29.38,0,0,1,29.36-29.4h223v71.8h54.9v-71.2a29.45,29.45,0,0,1,23.4,28.8v116.8a29.5,29.5,0,0,1-29.5,29.5H327.76l-36.1-36.1Zm1566.8,29.4h228.2l43.2-43.2h48.4l-3.1-102.9a33.72,33.72,0,0,0-33.7-32.7h-191.6v81.2h-49.5v-81.2h-75.6v145a33.75,33.75,0,0,0,33.7,33.8Zm250.9,102.9h-812.3a10.5,10.5,0,0,0-10.5,10.5v157.6a9.4,9.4,0,0,0,9.4,9.4h799.5a45.4,45.4,0,0,0,45.4-45.4V601.07a31.5,31.5,0,0,0-31.5-31.5Zm-963.3,177.5a15.7,15.7,0,0,0,15.7-15.7V585.27a15.7,15.7,0,0,0-15.7-15.7H351.26a46.75,46.75,0,0,0-46.8,46.7h0v97.5a33.3,33.3,0,0,0,33.3,33.3Zm-441.3-280.7H951v.3h106.5v-.3h74.2v.3h162.2v-.3h396.6a4.6,4.6,0,0,0,4.6-4.58V293.37a4.6,4.6,0,0,0-4.58-4.6H651.56a4.6,4.6,0,0,0-4.6,4.58V461.77a4.6,4.6,0,0,0,4.58,4.6Zm456.88,538.89V857.37H329.86v9h330v280.7h98v-92.58l311.14-8.66a40.59,40.59,0,0,0,39.44-40.57Zm938-152.59H1238.86a5.4,5.4,0,0,0-5.4,5.4h0v148.3a32.81,32.81,0,0,0,32.8,32.8h66.6a10.12,10.12,0,0,0,10.2-10V863.67H2052v-5.5a5.52,5.52,0,0,0-5.5-5.5Zm-874.4,166a110.25,110.25,0,0,1-103.4,104l-54.1,3.3-2,1.9,328.4-9.6-69.2-.8a101,101,0,0,1-99.68-98.8Z"
            />
            <g #svgRectGElement id="PLACES">
                <rect
                    id="_201"
                    data-name="201"
                    class="cls-7"
                    x="1045.66"
                    y="865.27"
                    width="50"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam"
                    class="cls-5"
                    x="1047.33"
                    y="917.51"
                    width="46.66"
                    height="22.76"
                />
                <rect
                    id="_202"
                    data-name="202"
                    class="cls-7"
                    x="997.06"
                    y="865.27"
                    width="48.6"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam-2"
                    class="cls-5"
                    x="998.73"
                    y="917.51"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_203"
                    data-name="203"
                    class="cls-7"
                    x="948.46"
                    y="865.27"
                    width="48.6"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam-3"
                    class="cls-5"
                    x="950.13"
                    y="917.51"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_204"
                    data-name="204"
                    class="cls-7"
                    x="899.96"
                    y="865.27"
                    width="48.6"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam-4"
                    class="cls-5"
                    x="901.53"
                    y="917.51"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_205"
                    data-name="205"
                    class="cls-7"
                    x="851.36"
                    y="865.27"
                    width="48.6"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam-5"
                    class="cls-5"
                    x="853.03"
                    y="917.51"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_206"
                    data-name="206"
                    class="cls-7"
                    x="802.86"
                    y="865.27"
                    width="48.6"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam-6"
                    class="cls-5"
                    x="804.53"
                    y="917.51"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_207"
                    data-name="207"
                    class="cls-7"
                    x="754.26"
                    y="865.27"
                    width="48.6"
                    height="75"
                />
                <rect
                    style="display: none"
                    id="rendszam-7"
                    class="cls-5"
                    x="755.93"
                    y="917.51"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_208"
                    data-name="208"
                    class="cls-7"
                    x="656.26"
                    y="865.27"
                    width="98.1"
                    height="47"
                />
                <rect
                    style="display: none"
                    id="rendszam-8"
                    class="cls-5"
                    x="657.07"
                    y="890.09"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_209"
                    data-name="209"
                    class="cls-7"
                    x="656.26"
                    y="912.17"
                    width="98.1"
                    height="47"
                />
                <rect
                    style="display: none"
                    id="rendszam-9"
                    class="cls-5"
                    x="657.07"
                    y="937.04"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_210"
                    data-name="210"
                    class="cls-7"
                    x="656.26"
                    y="959.17"
                    width="98.1"
                    height="50.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-10"
                    class="cls-5"
                    x="656.82"
                    y="987.68"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_211"
                    data-name="211"
                    class="cls-7"
                    x="656.26"
                    y="1009.37"
                    width="98.1"
                    height="47"
                />
                <rect
                    style="display: none"
                    id="rendszam-11"
                    class="cls-5"
                    x="657.07"
                    y="1034.19"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_212"
                    data-name="212"
                    class="cls-7"
                    x="656.26"
                    y="1056.37"
                    width="98.1"
                    height="45.23"
                />
                <rect
                    style="display: none"
                    id="rendszam-12"
                    class="cls-5"
                    x="656.63"
                    y="1080.62"
                    width="64.19"
                    height="22.77"
                    transform="translate(-32.47 21.16) rotate(-1.72)"
                />
                <rect
                    id="_213"
                    data-name="213"
                    class="cls-7"
                    x="656.3"
                    y="1101.54"
                    width="98.1"
                    height="43.91"
                    transform="translate(-40.5 26.47) rotate(-2.09)"
                />
                <rect
                    style="display: none"
                    id="rendszam-13"
                    class="cls-5"
                    x="655.57"
                    y="1125.27"
                    width="64.19"
                    height="22.77"
                    transform="translate(-33.81 21.15) rotate(-1.72)"
                />
                <rect
                    id="_214"
                    data-name="214"
                    class="cls-7"
                    x="428.37"
                    y="1108.54"
                    width="94.49"
                    height="45.23"
                    transform="translate(-41.13 18.19) rotate(-2.1)"
                />
                <rect
                    style="display: none"
                    id="rendszam-14"
                    class="cls-5"
                    x="423.88"
                    y="1133.73"
                    width="64.26"
                    height="22.8"
                    transform="translate(-45.4 19.14) rotate(-2.29)"
                />
                <rect
                    id="_215"
                    data-name="215"
                    class="cls-7"
                    x="427.34"
                    y="1059.64"
                    width="95"
                    height="49.97"
                    transform="translate(-10.39 4.61) rotate(-0.55)"
                />
                <rect
                    style="display: none"
                    id="rendszam-15"
                    class="cls-5"
                    x="428.83"
                    y="1086.07"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_216"
                    data-name="216"
                    class="cls-7"
                    x="427.26"
                    y="1013.47"
                    width="95.13"
                    height="47.73"
                />
                <rect
                    style="display: none"
                    id="rendszam-16"
                    class="cls-5"
                    x="428.83"
                    y="1036.91"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_217"
                    data-name="217"
                    class="cls-7"
                    x="427.26"
                    y="961.74"
                    width="95.13"
                    height="51.73"
                />
                <rect
                    style="display: none"
                    id="rendszam-17"
                    class="cls-5"
                    x="428.33"
                    y="990.84"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_218"
                    data-name="218"
                    class="cls-7"
                    x="427.26"
                    y="910.92"
                    width="94.72"
                    height="51.51"
                />
                <rect
                    style="display: none"
                    id="rendszam-18"
                    class="cls-5"
                    x="428.33"
                    y="939.57"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_219"
                    data-name="219"
                    class="cls-7"
                    x="428.46"
                    y="865.27"
                    width="93.52"
                    height="45.65"
                />
                <rect
                    style="display: none"
                    id="rendszam-19"
                    class="cls-5"
                    x="428.33"
                    y="888.09"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_220"
                    data-name="220"
                    class="cls-7"
                    x="328.15"
                    y="865.27"
                    width="100.31"
                    height="50.25"
                />
                <rect
                    style="display: none"
                    id="rendszam-20"
                    class="cls-5"
                    x="331.59"
                    y="892.12"
                    width="64.21"
                    height="22.78"
                    transform="matrix(1, -0.04, 0.04, 1, -35.81, 15.25)"
                />
                <rect
                    id="_221"
                    data-name="221"
                    class="cls-7"
                    x="328.93"
                    y="915.58"
                    width="98.3"
                    height="46.92"
                    transform="translate(-34.16 14.48) rotate(-2.1)"
                />
                <rect
                    style="display: none"
                    id="rendszam-21"
                    class="cls-5"
                    x="333.51"
                    y="939.92"
                    width="64.21"
                    height="22.78"
                    transform="matrix(1, -0.04, 0.04, 1, -37.72, 15.37)"
                />
                <rect
                    id="_222"
                    data-name="222"
                    class="cls-7"
                    x="330.9"
                    y="962.47"
                    width="97.47"
                    height="52.71"
                    transform="translate(-35.98 14.58) rotate(-2.1)"
                />
                <rect
                    style="display: none"
                    id="rendszam-22"
                    class="cls-5"
                    x="334.57"
                    y="992.45"
                    width="64.21"
                    height="22.78"
                    transform="matrix(1, -0.04, 0.04, 1, -39.82, 15.45)"
                />
                <rect
                    id="_223"
                    data-name="223"
                    class="cls-7"
                    x="332.05"
                    y="1015.17"
                    width="96.83"
                    height="45.24"
                    transform="translate(-37.77 14.64) rotate(-2.1)"
                />
                <rect
                    style="display: none"
                    id="rendszam-23"
                    class="cls-5"
                    x="336.39"
                    y="1037.58"
                    width="64.21"
                    height="22.78"
                    transform="translate(-41.63 15.57) rotate(-2.29)"
                />
                <rect
                    id="_224"
                    data-name="224"
                    class="cls-7"
                    x="335.07"
                    y="1059.71"
                    width="92.92"
                    height="50.35"
                    transform="translate(-39.5 14.71) rotate(-2.1)"
                />
                <rect
                    style="display: none"
                    id="rendszam-24"
                    class="cls-5"
                    x="339.47"
                    y="1088.15"
                    width="64.21"
                    height="22.78"
                    transform="matrix(1, -0.04, 0.04, 1, -43.64, 15.73)"
                />
                <rect
                    id="_225"
                    data-name="225"
                    class="cls-7"
                    x="336.39"
                    y="1109.54"
                    width="92.39"
                    height="46.15"
                    transform="translate(-44.95 16.19) rotate(-2.29)"
                />
                <rect
                    style="display: none"
                    id="rendszam-25"
                    class="cls-5"
                    x="340.23"
                    y="1133.42"
                    width="64.21"
                    height="22.78"
                    transform="matrix(1, -0.04, 0.04, 1, -45.45, 15.79)"
                />
                <rect
                    id="_226"
                    data-name="226"
                    class="cls-7"
                    x="108.18"
                    y="1119.16"
                    width="87.29"
                    height="45.56"
                    transform="translate(-34.21 5.07) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-26"
                    class="cls-5"
                    x="109.7"
                    y="1142.31"
                    width="64.16"
                    height="22.76"
                    transform="translate(-37.17 5.18) rotate(-1.85)"
                />
                <rect
                    id="_227"
                    data-name="227"
                    class="cls-7"
                    x="106.31"
                    y="1071.49"
                    width="87.29"
                    height="47.39"
                    transform="translate(-32.8 4.99) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-27"
                    class="cls-5"
                    x="106.92"
                    y="1097.11"
                    width="64.16"
                    height="22.76"
                    transform="translate(-35.71 5.07) rotate(-1.85)"
                />
                <rect
                    id="_228"
                    data-name="228"
                    class="cls-7"
                    x="104.24"
                    y="1023.33"
                    width="87.94"
                    height="48.55"
                    transform="translate(-31.38 4.92) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-28"
                    class="cls-5"
                    x="104.85"
                    y="1050.18"
                    width="64.16"
                    height="22.76"
                    transform="translate(-34.2 4.97) rotate(-1.85)"
                />
                <rect
                    id="_229"
                    data-name="229"
                    class="cls-7"
                    x="103.26"
                    y="974.26"
                    width="87.9"
                    height="50.23"
                    transform="translate(-32.19 5.27) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-29"
                    class="cls-5"
                    x="103.87"
                    y="1002.11"
                    width="64.16"
                    height="22.76"
                    transform="translate(-32.65 4.92) rotate(-1.85)"
                />
                <rect
                    id="_230"
                    data-name="230"
                    class="cls-7"
                    x="101.59"
                    y="922.24"
                    width="87.94"
                    height="51.42"
                    transform="translate(-28.39 4.8) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-30"
                    class="cls-5"
                    x="100.12"
                    y="952.22"
                    width="64.19"
                    height="22.77"
                    transform="translate(-28.86 4.4) rotate(-1.72)"
                />
                <rect
                    id="_231"
                    data-name="231"
                    class="cls-7"
                    x="99.69"
                    y="874.58"
                    width="88.35"
                    height="48.06"
                    transform="translate(-26.91 4.72) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-31"
                    class="cls-5"
                    x="99.34"
                    y="900.16"
                    width="64.16"
                    height="22.76"
                    transform="translate(-29.36 4.72) rotate(-1.85)"
                />
                <rect
                    id="_232"
                    data-name="232"
                    class="cls-7"
                    x="98.07"
                    y="827.31"
                    width="88.31"
                    height="47.95"
                    transform="translate(-27.41 5.04) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-32"
                    class="cls-5"
                    x="95.6"
                    y="853.99"
                    width="64.19"
                    height="22.77"
                    transform="translate(-25.92 4.22) rotate(-1.72)"
                />
                <rect
                    id="_233"
                    data-name="233"
                    class="cls-7"
                    x="95.75"
                    y="778.39"
                    width="89.06"
                    height="48.77"
                    transform="translate(-25.84 4.95) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-33"
                    class="cls-5"
                    x="95.98"
                    y="805.01"
                    width="64.16"
                    height="22.76"
                    transform="translate(-26.29 4.56) rotate(-1.85)"
                />
                <rect
                    id="_234"
                    data-name="234"
                    class="cls-7"
                    x="94.19"
                    y="730.21"
                    width="89.06"
                    height="48.2"
                    transform="translate(-24.28 4.87) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-34"
                    class="cls-5"
                    x="94.44"
                    y="756.14"
                    width="64.16"
                    height="22.76"
                    transform="translate(-24.71 4.48) rotate(-1.85)"
                />
                <rect
                    id="_235"
                    data-name="235"
                    class="cls-7"
                    x="91.84"
                    y="680.23"
                    width="89.81"
                    height="50.03"
                    transform="translate(-22.7 4.78) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-35"
                    class="cls-5"
                    x="92.44"
                    y="707.11"
                    width="64.16"
                    height="22.76"
                    transform="translate(-23.13 4.39) rotate(-1.85)"
                />
                <rect
                    id="_236"
                    data-name="236"
                    class="cls-7"
                    x="90.45"
                    y="635.17"
                    width="89.75"
                    height="45.61"
                    transform="translate(-19.69 4.36) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-36"
                    class="cls-5"
                    x="90.53"
                    y="657.7"
                    width="64.16"
                    height="22.76"
                    transform="translate(-21.54 4.31) rotate(-1.85)"
                />
                <rect
                    id="_237"
                    data-name="237"
                    class="cls-7"
                    x="88.42"
                    y="588"
                    width="90.21"
                    height="46.58"
                    transform="translate(-19.66 4.63) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-37"
                    class="cls-5"
                    x="88.45"
                    y="611.49"
                    width="64.16"
                    height="22.76"
                    transform="translate(-20.05 4.22) rotate(-1.85)"
                />
                <rect
                    id="_238"
                    data-name="238"
                    class="cls-7"
                    x="86.31"
                    y="539.46"
                    width="90.77"
                    height="48.43"
                    transform="translate(-18.13 4.55) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-38"
                    class="cls-5"
                    x="86.39"
                    y="565.23"
                    width="64.16"
                    height="22.76"
                    transform="translate(-18.55 4.13) rotate(-1.85)"
                />
                <rect
                    id="_239"
                    data-name="239"
                    class="cls-7"
                    x="83.81"
                    y="487.95"
                    width="91.67"
                    height="51.57"
                    transform="translate(-16.52 4.45) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-39"
                    class="cls-5"
                    x="84.22"
                    y="516.22"
                    width="64.16"
                    height="22.76"
                    transform="translate(-16.97 4.03) rotate(-1.85)"
                />
                <rect
                    id="_240"
                    data-name="240"
                    class="cls-7"
                    x="82.14"
                    y="436.35"
                    width="91.67"
                    height="51.62"
                    transform="translate(-14.85 4.37) rotate(-1.85)"
                />
                <rect
                    style="display: none"
                    id="rendszam-40"
                    class="cls-5"
                    x="82.22"
                    y="465.02"
                    width="64.16"
                    height="22.76"
                    transform="translate(-15.32 3.94) rotate(-1.85)"
                />
                <rect
                    id="_241"
                    data-name="241"
                    class="cls-7"
                    x="1045.66"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-41"
                    class="cls-5"
                    x="1048.03"
                    y="723.21"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_242"
                    data-name="242"
                    class="cls-7"
                    x="996.36"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-42"
                    class="cls-5"
                    x="998.73"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_243"
                    data-name="243"
                    class="cls-7"
                    x="947.06"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-43"
                    class="cls-5"
                    x="949.43"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_244"
                    data-name="244"
                    class="cls-7"
                    x="897.86"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-44"
                    class="cls-5"
                    x="900.13"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_245"
                    data-name="245"
                    class="cls-7"
                    x="851.76"
                    y="658.77"
                    width="46.8"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-45"
                    class="cls-5"
                    x="854.23"
                    y="723.21"
                    width="41.86"
                    height="22.76"
                />
                <rect
                    id="_246"
                    data-name="246"
                    class="cls-7"
                    x="802.56"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-46"
                    class="cls-5"
                    x="804.93"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_247"
                    data-name="247"
                    class="cls-7"
                    x="753.26"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-47"
                    class="cls-5"
                    x="755.63"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_248"
                    data-name="248"
                    class="cls-7"
                    x="703.96"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-48"
                    class="cls-5"
                    x="706.33"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_249"
                    data-name="249"
                    class="cls-7"
                    x="654.76"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-49"
                    class="cls-5"
                    x="657.03"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_250"
                    data-name="250"
                    class="cls-7"
                    x="605.46"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-50"
                    class="cls-5"
                    x="607.73"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_251"
                    data-name="251"
                    class="cls-7"
                    x="556.16"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-51"
                    class="cls-5"
                    x="558.43"
                    y="723.21"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_252"
                    data-name="252"
                    class="cls-7"
                    x="494.06"
                    y="658.77"
                    width="62.9"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-52"
                    class="cls-5"
                    x="496.43"
                    y="723.21"
                    width="57.96"
                    height="22.76"
                />
                <rect
                    id="_253"
                    data-name="253"
                    class="cls-7"
                    x="431.86"
                    y="658.77"
                    width="62.9"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-53"
                    class="cls-5"
                    x="434.33"
                    y="723.21"
                    width="57.96"
                    height="22.76"
                />
                <rect
                    id="_254"
                    data-name="254"
                    class="cls-7"
                    x="382.56"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-54"
                    class="cls-5"
                    x="384.93"
                    y="723.21"
                    width="45.35"
                    height="22.76"
                />
                <rect
                    id="_255"
                    data-name="255"
                    class="cls-7"
                    x="333.26"
                    y="658.77"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-55"
                    class="cls-5"
                    x="334.93"
                    y="723.21"
                    width="46"
                    height="22.76"
                />
                <rect
                    id="_256"
                    data-name="256"
                    class="cls-7"
                    x="333.26"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-56"
                    class="cls-5"
                    x="334.93"
                    y="636.04"
                    width="46"
                    height="22.76"
                />
                <rect
                    id="_257"
                    data-name="257"
                    class="cls-7"
                    x="382.56"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-57"
                    class="cls-5"
                    x="384.93"
                    y="636.04"
                    width="45.35"
                    height="22.76"
                />
                <rect
                    id="_258"
                    data-name="258"
                    class="cls-7"
                    x="431.86"
                    y="571.67"
                    width="62.9"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-58"
                    class="cls-5"
                    x="434.33"
                    y="636.04"
                    width="57.96"
                    height="22.76"
                />
                <rect
                    id="_259"
                    data-name="259"
                    class="cls-7"
                    x="494.06"
                    y="571.67"
                    width="62.9"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-59"
                    class="cls-5"
                    x="496.43"
                    y="636.04"
                    width="57.96"
                    height="22.76"
                />
                <rect
                    id="_260"
                    data-name="260"
                    class="cls-7"
                    x="556.16"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-60"
                    class="cls-5"
                    x="558.43"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_261"
                    data-name="261"
                    class="cls-7"
                    x="605.46"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-61"
                    class="cls-5"
                    x="607.73"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_262"
                    data-name="262"
                    class="cls-7"
                    x="654.76"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-62"
                    class="cls-5"
                    x="657.03"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_263"
                    data-name="263"
                    class="cls-7"
                    x="703.96"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-63"
                    class="cls-5"
                    x="706.33"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_264"
                    data-name="264"
                    class="cls-7"
                    x="753.26"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-64"
                    class="cls-5"
                    x="755.63"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_265"
                    data-name="265"
                    class="cls-7"
                    x="802.56"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-65"
                    class="cls-5"
                    x="804.93"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_266"
                    data-name="266"
                    class="cls-7"
                    x="851.76"
                    y="571.67"
                    width="46.8"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-66"
                    class="cls-5"
                    x="854.23"
                    y="636.04"
                    width="41.86"
                    height="22.76"
                />
                <rect
                    id="_267"
                    data-name="267"
                    class="cls-7"
                    x="897.86"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-67"
                    class="cls-5"
                    x="900.13"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_268"
                    data-name="268"
                    class="cls-7"
                    x="947.06"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-68"
                    class="cls-5"
                    x="949.43"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_269"
                    data-name="269"
                    class="cls-7"
                    x="996.36"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-69"
                    class="cls-5"
                    x="998.73"
                    y="636.04"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_270"
                    data-name="270"
                    class="cls-7"
                    x="1045.66"
                    y="571.67"
                    width="50"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-70"
                    class="cls-5"
                    x="1048.03"
                    y="636.04"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_271"
                    data-name="271"
                    class="cls-7"
                    x="898.56"
                    y="376.37"
                    width="48.8"
                    height="89.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-71"
                    class="cls-5"
                    x="899.98"
                    y="442.81"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_272"
                    data-name="272"
                    class="cls-7"
                    x="849.76"
                    y="376.37"
                    width="48.8"
                    height="89.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-72"
                    class="cls-5"
                    x="851.18"
                    y="442.81"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_273"
                    data-name="273"
                    class="cls-7"
                    x="801.06"
                    y="376.37"
                    width="48.8"
                    height="89.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-73"
                    class="cls-5"
                    x="802.38"
                    y="442.81"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_274"
                    data-name="274"
                    class="cls-7"
                    x="752.26"
                    y="376.37"
                    width="48.8"
                    height="89.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-74"
                    class="cls-5"
                    x="753.58"
                    y="442.81"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_275"
                    data-name="275"
                    class="cls-7"
                    x="703.46"
                    y="376.37"
                    width="48.8"
                    height="89.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-75"
                    class="cls-5"
                    x="704.78"
                    y="442.81"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_276"
                    data-name="276"
                    class="cls-7"
                    x="654.76"
                    y="376.37"
                    width="48.8"
                    height="89.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-76"
                    class="cls-5"
                    x="655.98"
                    y="442.81"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_277"
                    data-name="277"
                    class="cls-7"
                    x="487.36"
                    y="296.57"
                    width="54.9"
                    height="71.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-77"
                    class="cls-5"
                    x="491.83"
                    y="345.24"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_278"
                    data-name="278"
                    class="cls-7"
                    x="173.26"
                    y="338.27"
                    width="61.6"
                    height="97.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-78"
                    class="cls-5"
                    x="181.08"
                    y="412.17"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_279"
                    data-name="279"
                    class="cls-7"
                    x="126.76"
                    y="338.27"
                    width="46.5"
                    height="97.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-79"
                    class="cls-5"
                    x="128.33"
                    y="412.17"
                    width="43.36"
                    height="22.76"
                />
                <rect
                    id="_280"
                    data-name="280"
                    class="cls-7"
                    x="80.16"
                    y="338.27"
                    width="46.5"
                    height="97.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-80"
                    class="cls-5"
                    x="81.59"
                    y="412.17"
                    width="43.36"
                    height="22.76"
                />
                <rect
                    id="_281"
                    data-name="281"
                    class="cls-7"
                    x="70.55"
                    y="92.47"
                    width="43.51"
                    height="96.66"
                />
                <rect
                    style="display: none"
                    id="rendszam-81"
                    class="cls-5"
                    x="70.55"
                    y="166.37"
                    width="41.84"
                    height="22.76"
                />
                <rect
                    id="_282"
                    data-name="282"
                    class="cls-7"
                    x="114.16"
                    y="92.47"
                    width="52.2"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-82"
                    class="cls-5"
                    x="115.73"
                    y="166.37"
                    width="49.13"
                    height="22.76"
                />
                <rect
                    id="_283"
                    data-name="283"
                    class="cls-7"
                    x="166.36"
                    y="92.47"
                    width="45.8"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-83"
                    class="cls-5"
                    x="168.03"
                    y="166.37"
                    width="42.46"
                    height="22.76"
                />
                <rect
                    id="_284"
                    data-name="284"
                    class="cls-7"
                    x="212.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-84"
                    class="cls-5"
                    x="213.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_285"
                    data-name="285"
                    class="cls-7"
                    x="261.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-85"
                    class="cls-5"
                    x="262.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_286"
                    data-name="286"
                    class="cls-7"
                    x="310.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-86"
                    class="cls-5"
                    x="311.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_287"
                    data-name="287"
                    class="cls-7"
                    x="359.16"
                    y="92.47"
                    width="52.2"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-87"
                    class="cls-5"
                    x="360.83"
                    y="166.37"
                    width="48.86"
                    height="22.76"
                />
                <rect
                    id="_288"
                    data-name="288"
                    class="cls-7"
                    x="411.36"
                    y="92.47"
                    width="45.8"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-88"
                    class="cls-5"
                    x="413.03"
                    y="166.37"
                    width="42.46"
                    height="22.76"
                />
                <rect
                    id="_289"
                    data-name="289"
                    class="cls-7"
                    x="457.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-89"
                    class="cls-5"
                    x="458.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_290"
                    data-name="290"
                    class="cls-7"
                    x="506.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-90"
                    class="cls-5"
                    x="507.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_291"
                    data-name="291"
                    class="cls-7"
                    x="555.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-91"
                    class="cls-5"
                    x="556.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_292"
                    data-name="292"
                    class="cls-7"
                    x="604.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-92"
                    class="cls-5"
                    x="605.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_293"
                    data-name="293"
                    class="cls-7"
                    x="653.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-93"
                    class="cls-5"
                    x="654.83"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_294"
                    data-name="294"
                    class="cls-7"
                    x="702.26"
                    y="92.47"
                    width="52.2"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-94"
                    class="cls-5"
                    x="703.83"
                    y="166.37"
                    width="48.96"
                    height="22.76"
                />
                <rect
                    id="_295"
                    data-name="295"
                    class="cls-7"
                    x="754.46"
                    y="92.47"
                    width="45.8"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-95"
                    class="cls-5"
                    x="756.13"
                    y="166.37"
                    width="42.46"
                    height="22.76"
                />
                <rect
                    id="_296"
                    data-name="296"
                    class="cls-7"
                    x="800.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-96"
                    class="cls-5"
                    x="801.8"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_297"
                    data-name="297"
                    class="cls-7"
                    x="849.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-97"
                    class="cls-5"
                    x="850.86"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_298"
                    data-name="298"
                    class="cls-7"
                    x="898.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-98"
                    class="cls-5"
                    x="899.93"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_299"
                    data-name="299"
                    class="cls-7"
                    x="947.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-99"
                    class="cls-5"
                    x="949"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_300"
                    data-name="300"
                    class="cls-7"
                    x="996.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-100"
                    class="cls-5"
                    x="998.06"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_301"
                    data-name="301"
                    class="cls-7"
                    x="1045.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-101"
                    class="cls-5"
                    x="1047.12"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_302"
                    data-name="302"
                    class="cls-7"
                    x="1094.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-102"
                    class="cls-5"
                    x="1095.86"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_303"
                    data-name="303"
                    class="cls-7"
                    x="1143.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-103"
                    class="cls-5"
                    x="1144.86"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_304"
                    data-name="304"
                    class="cls-7"
                    x="1192.36"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-104"
                    class="cls-5"
                    x="1193.86"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_305"
                    data-name="305"
                    class="cls-7"
                    x="1241.36"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-105"
                    class="cls-5"
                    x="1242.86"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_306"
                    data-name="306"
                    class="cls-7"
                    x="1290.36"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-106"
                    class="cls-5"
                    x="1291.86"
                    y="166.37"
                    width="45.79"
                    height="22.76"
                />
                <rect
                    id="_307"
                    data-name="307"
                    class="cls-7"
                    x="1339.26"
                    y="92.47"
                    width="45.8"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-107"
                    class="cls-5"
                    x="1340.87"
                    y="166.37"
                    width="42.52"
                    height="22.76"
                />
                <rect
                    id="_308"
                    data-name="308"
                    class="cls-7"
                    x="1385.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-108"
                    class="cls-5"
                    x="1386.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_309"
                    data-name="309"
                    class="cls-7"
                    x="1434.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-109"
                    class="cls-5"
                    x="1435.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_310"
                    data-name="310"
                    class="cls-7"
                    x="1483.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-110"
                    class="cls-5"
                    x="1484.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_311"
                    data-name="311"
                    class="cls-7"
                    x="1532.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-111"
                    class="cls-5"
                    x="1533.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_312"
                    data-name="312"
                    class="cls-7"
                    x="1581.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-112"
                    class="cls-5"
                    x="1582.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_313"
                    data-name="313"
                    class="cls-7"
                    x="1630.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-113"
                    class="cls-5"
                    x="1631.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_314"
                    data-name="314"
                    class="cls-7"
                    x="1679.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-114"
                    class="cls-5"
                    x="1680.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_315"
                    data-name="315"
                    class="cls-7"
                    x="1728.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-115"
                    class="cls-5"
                    x="1729.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_316"
                    data-name="316"
                    class="cls-7"
                    x="1777.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-116"
                    class="cls-5"
                    x="1778.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_317"
                    data-name="317"
                    class="cls-7"
                    x="1826.16"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-117"
                    class="cls-5"
                    x="1827.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_318"
                    data-name="318"
                    class="cls-7"
                    x="1875.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-118"
                    class="cls-5"
                    x="1876.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_319"
                    data-name="319"
                    class="cls-7"
                    x="1924.26"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-119"
                    class="cls-5"
                    x="1925.73"
                    y="166.37"
                    width="45.86"
                    height="22.76"
                />
                <rect
                    id="_320"
                    data-name="320"
                    class="cls-7"
                    x="1973.16"
                    y="92.47"
                    width="45.8"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-120"
                    class="cls-5"
                    x="1974.73"
                    y="166.37"
                    width="42.56"
                    height="22.76"
                />
                <rect
                    id="_321"
                    data-name="321"
                    class="cls-7"
                    x="2018.96"
                    y="92.47"
                    width="55.5"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-121"
                    class="cls-5"
                    x="2020.63"
                    y="166.37"
                    width="52.16"
                    height="22.76"
                />
                <rect
                    id="_322"
                    data-name="322"
                    class="cls-7"
                    x="2074.46"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-122"
                    class="cls-5"
                    x="2076.13"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_323"
                    data-name="323"
                    class="cls-7"
                    x="2123.46"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-123"
                    class="cls-5"
                    x="2125.13"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_324"
                    data-name="324"
                    class="cls-7"
                    x="2172.46"
                    y="92.47"
                    width="49"
                    height="96.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-124"
                    class="cls-5"
                    x="2174.13"
                    y="166.37"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_325"
                    data-name="325"
                    class="cls-7"
                    x="2221.46"
                    y="92.37"
                    width="44.28"
                    height="96.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-125"
                    class="cls-5"
                    x="2223.13"
                    y="166.37"
                    width="42.07"
                    height="22.76"
                />
                <rect
                    id="_326"
                    data-name="326"
                    class="cls-7"
                    x="2227.66"
                    y="319.97"
                    width="45.2"
                    height="96.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-126"
                    class="cls-5"
                    x="2229.33"
                    y="393.87"
                    width="41.86"
                    height="22.76"
                />
                <rect
                    id="_327"
                    data-name="327"
                    class="cls-7"
                    x="2179.76"
                    y="319.97"
                    width="47.9"
                    height="96.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-127"
                    class="cls-5"
                    x="2181.43"
                    y="393.87"
                    width="44.56"
                    height="22.76"
                />
                <rect
                    id="_328"
                    data-name="328"
                    class="cls-7"
                    x="2121.36"
                    y="319.97"
                    width="58.4"
                    height="96.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-128"
                    class="cls-5"
                    x="2123.03"
                    y="393.87"
                    width="55.06"
                    height="22.76"
                />
                <rect
                    id="_329"
                    data-name="329"
                    class="cls-7"
                    x="1843.56"
                    y="286.87"
                    width="49.5"
                    height="81.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-129"
                    class="cls-5"
                    x="1845.23"
                    y="345.54"
                    width="46.16"
                    height="22.76"
                />
                <rect
                    id="_330"
                    data-name="330"
                    class="cls-7"
                    x="654.76"
                    y="290.97"
                    width="48.8"
                    height="85.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-130"
                    class="cls-5"
                    x="656.53"
                    y="352.89"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_331"
                    data-name="331"
                    class="cls-7"
                    x="703.46"
                    y="290.97"
                    width="48.8"
                    height="85.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-131"
                    class="cls-5"
                    x="705.23"
                    y="352.89"
                    width="45.26"
                    height="22.76"
                />
                <rect
                    id="_332"
                    data-name="332"
                    class="cls-7"
                    x="752.26"
                    y="290.97"
                    width="48.8"
                    height="85.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-132"
                    class="cls-5"
                    x="753.93"
                    y="352.89"
                    width="45.36"
                    height="22.76"
                />
                <rect
                    id="_333"
                    data-name="333"
                    class="cls-7"
                    x="801.06"
                    y="290.97"
                    width="48.8"
                    height="85.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-133"
                    class="cls-5"
                    x="802.63"
                    y="352.89"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_334"
                    data-name="334"
                    class="cls-7"
                    x="849.76"
                    y="290.97"
                    width="48.8"
                    height="85.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-134"
                    class="cls-5"
                    x="851.43"
                    y="352.89"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_335"
                    data-name="335"
                    class="cls-7"
                    x="898.56"
                    y="290.97"
                    width="48.8"
                    height="85.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-135"
                    class="cls-5"
                    x="900.23"
                    y="352.89"
                    width="45.46"
                    height="22.76"
                />
                <rect
                    id="_336"
                    data-name="336"
                    class="cls-7"
                    x="947.26"
                    y="290.87"
                    width="50.7"
                    height="77.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-136"
                    class="cls-5"
                    x="949.03"
                    y="345.89"
                    width="47.16"
                    height="22.76"
                />
                <rect
                    id="_337"
                    data-name="337"
                    class="cls-7"
                    x="998.56"
                    y="290.87"
                    width="45.6"
                    height="77.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-137"
                    class="cls-5"
                    x="1000.23"
                    y="345.89"
                    width="42.26"
                    height="22.76"
                />
                <rect
                    id="_338"
                    data-name="338"
                    class="cls-7"
                    x="1295.96"
                    y="290.97"
                    width="43.4"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-138"
                    class="cls-5"
                    x="1297.63"
                    y="352.39"
                    width="39.92"
                    height="22.76"
                />
                <rect
                    id="_339"
                    data-name="339"
                    class="cls-7"
                    x="1339.36"
                    y="290.97"
                    width="46.6"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-139"
                    class="cls-5"
                    x="1341.03"
                    y="352.39"
                    width="43.26"
                    height="22.76"
                />
                <rect
                    id="_340"
                    data-name="340"
                    class="cls-7"
                    x="1385.96"
                    y="290.97"
                    width="49.9"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-140"
                    class="cls-5"
                    x="1387.63"
                    y="352.39"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_341"
                    data-name="341"
                    class="cls-7"
                    x="1435.86"
                    y="290.97"
                    width="46.6"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-141"
                    class="cls-5"
                    x="1437.53"
                    y="352.39"
                    width="43.26"
                    height="22.76"
                />
                <rect
                    id="_342"
                    data-name="342"
                    class="cls-7"
                    x="1482.56"
                    y="290.97"
                    width="46.6"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-142"
                    class="cls-5"
                    x="1484.13"
                    y="352.39"
                    width="43.26"
                    height="22.76"
                />
                <rect
                    id="_343"
                    data-name="343"
                    class="cls-7"
                    x="1529.06"
                    y="290.97"
                    width="49.9"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-143"
                    class="cls-5"
                    x="1530.73"
                    y="352.39"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_344"
                    data-name="344"
                    class="cls-7"
                    x="1578.96"
                    y="290.97"
                    width="49.9"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-144"
                    class="cls-5"
                    x="1580.63"
                    y="352.39"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_345"
                    data-name="345"
                    class="cls-7"
                    x="1628.86"
                    y="290.97"
                    width="49.9"
                    height="85.3"
                />
                <rect
                    style="display: none"
                    id="rendszam-145"
                    class="cls-5"
                    x="1630.53"
                    y="352.39"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_346"
                    data-name="346"
                    class="cls-7"
                    x="1295.96"
                    y="376.17"
                    width="43.4"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-146"
                    class="cls-5"
                    x="1297.63"
                    y="442.61"
                    width="39.92"
                    height="22.76"
                />
                <rect
                    id="_347"
                    data-name="347"
                    class="cls-7"
                    x="1339.36"
                    y="376.17"
                    width="46.6"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-147"
                    class="cls-5"
                    x="1341.03"
                    y="442.61"
                    width="43.26"
                    height="22.76"
                />
                <rect
                    id="_348"
                    data-name="348"
                    class="cls-7"
                    x="1385.96"
                    y="376.17"
                    width="49.9"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-148"
                    class="cls-5"
                    x="1387.63"
                    y="442.61"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_349"
                    data-name="349"
                    class="cls-7"
                    x="1435.86"
                    y="376.17"
                    width="46.6"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-149"
                    class="cls-5"
                    x="1437.53"
                    y="442.61"
                    width="43.26"
                    height="22.76"
                />
                <rect
                    id="_350"
                    data-name="350"
                    class="cls-7"
                    x="1482.56"
                    y="376.17"
                    width="46.6"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-150"
                    class="cls-5"
                    x="1484.13"
                    y="442.61"
                    width="43.26"
                    height="22.76"
                />
                <rect
                    id="_351"
                    data-name="351"
                    class="cls-7"
                    x="1529.06"
                    y="376.17"
                    width="49.9"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-151"
                    class="cls-5"
                    x="1530.73"
                    y="442.61"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_352"
                    data-name="352"
                    class="cls-7"
                    x="1578.96"
                    y="376.17"
                    width="49.9"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-152"
                    class="cls-5"
                    x="1580.63"
                    y="442.61"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_353"
                    data-name="353"
                    class="cls-7"
                    x="1628.86"
                    y="376.17"
                    width="49.9"
                    height="89.4"
                />
                <rect
                    style="display: none"
                    id="rendszam-153"
                    class="cls-5"
                    x="1630.53"
                    y="442.61"
                    width="46.56"
                    height="22.76"
                />
                <rect
                    id="_354"
                    data-name="354"
                    class="cls-7"
                    x="1241.26"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-154"
                    class="cls-5"
                    x="1242.78"
                    y="636.04"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_355"
                    data-name="355"
                    class="cls-7"
                    x="1290.26"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-155"
                    class="cls-5"
                    x="1291.78"
                    y="636.04"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_356"
                    data-name="356"
                    class="cls-7"
                    x="1339.36"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-156"
                    class="cls-5"
                    x="1340.78"
                    y="636.04"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_357"
                    data-name="357"
                    class="cls-7"
                    x="1388.36"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-157"
                    class="cls-5"
                    x="1389.78"
                    y="636.04"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_358"
                    data-name="358"
                    class="cls-7"
                    x="1437.46"
                    y="571.67"
                    width="45.7"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-158"
                    class="cls-5"
                    x="1439.13"
                    y="636.04"
                    width="42.36"
                    height="22.76"
                />
                <rect
                    id="_359"
                    data-name="359"
                    class="cls-7"
                    x="1483.26"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-159"
                    class="cls-5"
                    x="1484.93"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_360"
                    data-name="360"
                    class="cls-7"
                    x="1532.26"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-160"
                    class="cls-5"
                    x="1533.93"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_361"
                    data-name="361"
                    class="cls-7"
                    x="1581.26"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-161"
                    class="cls-5"
                    x="1582.93"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_362"
                    data-name="362"
                    class="cls-7"
                    x="1630.26"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-162"
                    class="cls-5"
                    x="1631.93"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_363"
                    data-name="363"
                    class="cls-7"
                    x="1679.36"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-163"
                    class="cls-5"
                    x="1680.93"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_364"
                    data-name="364"
                    class="cls-7"
                    x="1728.36"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-164"
                    class="cls-5"
                    x="1729.93"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_365"
                    data-name="365"
                    class="cls-7"
                    x="1777.46"
                    y="571.67"
                    width="52.2"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-165"
                    class="cls-5"
                    x="1778.93"
                    y="636.04"
                    width="49.06"
                    height="22.76"
                />
                <rect
                    id="_366"
                    data-name="366"
                    class="cls-7"
                    x="1829.76"
                    y="571.67"
                    width="55.4"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-166"
                    class="cls-5"
                    x="1831.43"
                    y="636.04"
                    width="52.06"
                    height="22.76"
                />
                <rect
                    id="_367"
                    data-name="367"
                    class="cls-7"
                    x="1885.26"
                    y="571.67"
                    width="55.4"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-167"
                    class="cls-5"
                    x="1886.93"
                    y="636.04"
                    width="52.06"
                    height="22.76"
                />
                <rect
                    id="_368"
                    data-name="368"
                    class="cls-7"
                    x="1940.66"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-168"
                    class="cls-5"
                    x="1942.33"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_369"
                    data-name="369"
                    class="cls-7"
                    x="1989.66"
                    y="571.67"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-169"
                    class="cls-5"
                    x="1991.33"
                    y="636.04"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_370"
                    data-name="370"
                    class="cls-7"
                    x="2182.22"
                    y="420.24"
                    width="91.54"
                    height="48.69"
                    transform="translate(-12.34 67.07) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-170"
                    class="cls-5"
                    x="2180.54"
                    y="442.02"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_371"
                    data-name="371"
                    class="cls-7"
                    x="2183.69"
                    y="469.01"
                    width="91.54"
                    height="48.77"
                    transform="translate(-13.8 67.14) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-171"
                    class="cls-5"
                    x="2182.98"
                    y="490.82"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_372"
                    data-name="372"
                    class="cls-7"
                    x="2185.16"
                    y="517.75"
                    width="91.54"
                    height="48.96"
                    transform="translate(-15.27 67.21) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-172"
                    class="cls-5"
                    x="2184.9"
                    y="539.59"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_373"
                    data-name="373"
                    class="cls-7"
                    x="2186.62"
                    y="566.69"
                    width="91.54"
                    height="48.75"
                    transform="translate(-16.74 67.27) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-173"
                    class="cls-5"
                    x="2186.5"
                    y="588.07"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_374"
                    data-name="374"
                    class="cls-7"
                    x="2188.08"
                    y="615.43"
                    width="91.54"
                    height="48.82"
                    transform="translate(-18.2 67.34) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-174"
                    class="cls-5"
                    x="2187.7"
                    y="636.87"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_375"
                    data-name="375"
                    class="cls-7"
                    x="2189.56"
                    y="664.39"
                    width="91.54"
                    height="48.6"
                    transform="translate(-19.66 67.4) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-175"
                    class="cls-5"
                    x="2188.7"
                    y="685.67"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_376"
                    data-name="376"
                    class="cls-7"
                    x="2191.02"
                    y="713.06"
                    width="91.54"
                    height="48.87"
                    transform="translate(-21.13 67.47) rotate(-1.72)"
                />
                <rect
                    style="display: none"
                    id="rendszam-176"
                    class="cls-5"
                    x="2191.56"
                    y="735.08"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_377"
                    data-name="377"
                    class="cls-7"
                    x="2192.86"
                    y="757.93"
                    width="91.5"
                    height="48.67"
                    transform="translate(-23.59 71.1) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-177"
                    class="cls-5"
                    x="2193.56"
                    y="782.62"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_378"
                    data-name="378"
                    class="cls-7"
                    x="2194.41"
                    y="806.67"
                    width="91.5"
                    height="48.48"
                    transform="translate(-25.13 71.17) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-178"
                    class="cls-5"
                    x="2194.76"
                    y="832.42"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_379"
                    data-name="379"
                    class="cls-7"
                    x="2195.95"
                    y="855.29"
                    width="91.5"
                    height="48.48"
                    transform="translate(-26.66 71.24) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-179"
                    class="cls-5"
                    x="2196.36"
                    y="881.07"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_380"
                    data-name="380"
                    class="cls-7"
                    x="2197.49"
                    y="903.95"
                    width="91.5"
                    height="49.15"
                    transform="translate(-28.21 71.32) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-180"
                    class="cls-5"
                    x="2197.96"
                    y="929.67"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_381"
                    data-name="381"
                    class="cls-7"
                    x="2199.05"
                    y="953.08"
                    width="91.5"
                    height="48.74"
                    transform="translate(-29.75 71.39) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-181"
                    class="cls-5"
                    x="2199.14"
                    y="978.37"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_382"
                    data-name="382"
                    class="cls-7"
                    x="2200.58"
                    y="1002"
                    width="91.5"
                    height="48.62"
                    transform="translate(-31.3 71.46) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-182"
                    class="cls-5"
                    x="2200.67"
                    y="1027.79"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_383"
                    data-name="383"
                    class="cls-7"
                    x="2202.11"
                    y="1050.58"
                    width="91.5"
                    height="47.62"
                    transform="translate(-32.81 71.54) rotate(-1.81)"
                />
                <rect
                    style="display: none"
                    id="rendszam-183"
                    class="cls-5"
                    x="2202.12"
                    y="1075.02"
                    width="64.16"
                    height="22.76"
                    transform="translate(-33.2 71.11) rotate(-1.81)"
                />
                <rect
                    id="_384"
                    data-name="384"
                    class="cls-7"
                    x="1953.56"
                    y="1056.57"
                    width="99"
                    height="47.75"
                />
                <rect
                    style="display: none"
                    id="rendszam-184"
                    class="cls-5"
                    x="1953.38"
                    y="1081.56"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_385"
                    data-name="385"
                    class="cls-7"
                    x="1952.08"
                    y="1008.07"
                    width="100.48"
                    height="48.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-185"
                    class="cls-5"
                    x="1953.38"
                    y="1034.53"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_386"
                    data-name="386"
                    class="cls-7"
                    x="1951.39"
                    y="959.57"
                    width="99.07"
                    height="48.5"
                />
                <rect
                    style="display: none"
                    id="rendszam-186"
                    class="cls-5"
                    x="1952.08"
                    y="986.03"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_387"
                    data-name="387"
                    class="cls-7"
                    x="1950.26"
                    y="911.03"
                    width="99.2"
                    height="48.54"
                />
                <rect
                    style="display: none"
                    id="rendszam-187"
                    class="cls-5"
                    x="1951.03"
                    y="937.55"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_388"
                    data-name="388"
                    class="cls-7"
                    x="1949.39"
                    y="862.77"
                    width="99.2"
                    height="48.26"
                />
                <rect
                    style="display: none"
                    id="rendszam-188"
                    class="cls-5"
                    x="1950.03"
                    y="888.27"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_389"
                    data-name="389"
                    class="cls-7"
                    x="1831.57"
                    y="863.67"
                    width="102.35"
                    height="47.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-189"
                    class="cls-5"
                    x="1832.19"
                    y="888.27"
                    width="65.42"
                    height="22.76"
                />
                <rect
                    id="_390"
                    data-name="390"
                    class="cls-7"
                    x="1833.66"
                    y="911.37"
                    width="101.49"
                    height="48.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-190"
                    class="cls-5"
                    x="1833.36"
                    y="937.55"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_391"
                    data-name="391"
                    class="cls-7"
                    x="1834.15"
                    y="960.07"
                    width="101.81"
                    height="48.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-191"
                    class="cls-5"
                    x="1834.45"
                    y="986.03"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_392"
                    data-name="392"
                    class="cls-7"
                    x="1834.99"
                    y="1008.77"
                    width="101.94"
                    height="48.8"
                />
                <rect
                    style="display: none"
                    id="rendszam-192"
                    class="cls-5"
                    x="1835.72"
                    y="1035.53"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_393"
                    data-name="393"
                    class="cls-7"
                    x="1836.31"
                    y="1057.57"
                    width="102.25"
                    height="50.21"
                />
                <rect
                    style="display: none"
                    id="rendszam-193"
                    class="cls-5"
                    x="1836.31"
                    y="1085.01"
                    width="65.58"
                    height="22.76"
                />
                <rect
                    id="_394"
                    data-name="394"
                    class="cls-7"
                    x="1582.36"
                    y="1065.57"
                    width="96.4"
                    height="51.6"
                />
                <rect
                    style="display: none"
                    id="rendszam-194"
                    class="cls-5"
                    x="1582.93"
                    y="1094.06"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_395"
                    data-name="395"
                    class="cls-7"
                    x="1582.36"
                    y="1010.67"
                    width="96.4"
                    height="54.9"
                />
                <rect
                    style="display: none"
                    id="rendszam-195"
                    class="cls-5"
                    x="1582.93"
                    y="1042.81"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_396"
                    data-name="396"
                    class="cls-7"
                    x="1582.36"
                    y="965.47"
                    width="96.4"
                    height="45.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-196"
                    class="cls-5"
                    x="1582.93"
                    y="987.03"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_397"
                    data-name="397"
                    class="cls-7"
                    x="1582.36"
                    y="913.87"
                    width="96.4"
                    height="51.6"
                />
                <rect
                    style="display: none"
                    id="rendszam-197"
                    class="cls-5"
                    x="1582.93"
                    y="941.69"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_398"
                    data-name="398"
                    class="cls-7"
                    x="1582.36"
                    y="862.67"
                    width="96.4"
                    height="51.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-198"
                    class="cls-5"
                    x="1582.93"
                    y="891.54"
                    width="64.16"
                    height="22.76"
                />
                <rect
                    id="_405"
                    data-name="405"
                    class="cls-7"
                    x="1241.36"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-199"
                    class="cls-5"
                    x="1243.03"
                    y="919.23"
                    width="44.66"
                    height="22.76"
                />
                <rect
                    id="_404"
                    data-name="404"
                    class="cls-7"
                    x="1289.36"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-200"
                    class="cls-5"
                    x="1291.43"
                    y="919.23"
                    width="44.26"
                    height="22.76"
                />
                <rect
                    id="_403"
                    data-name="403"
                    class="cls-7"
                    x="1337.46"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-201"
                    class="cls-5"
                    x="1339.73"
                    y="919.23"
                    width="44.26"
                    height="22.76"
                />
                <rect
                    id="_402"
                    data-name="402"
                    class="cls-7"
                    x="1385.46"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-202"
                    class="cls-5"
                    x="1388.36"
                    y="919.23"
                    width="43.43"
                    height="22.76"
                />
                <rect
                    id="_401"
                    data-name="401"
                    class="cls-7"
                    x="1433.46"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-203"
                    class="cls-5"
                    x="1436.15"
                    y="919.23"
                    width="43.43"
                    height="22.76"
                />
                <rect
                    id="_400"
                    data-name="400"
                    class="cls-7"
                    x="1481.46"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-204"
                    class="cls-5"
                    x="1483.93"
                    y="919.23"
                    width="43.43"
                    height="22.76"
                />
                <rect
                    id="_399"
                    data-name="399"
                    class="cls-7"
                    x="1529.56"
                    y="862.57"
                    width="48.8"
                    height="80.7"
                />
                <rect
                    style="display: none"
                    id="rendszam-205"
                    class="cls-5"
                    x="1531.71"
                    y="919.23"
                    width="44.95"
                    height="22.76"
                />
                <rect
                    id="_421"
                    data-name="421"
                    class="cls-7"
                    x="1241.26"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-206"
                    class="cls-5"
                    x="1242.78"
                    y="723.21"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_420"
                    data-name="420"
                    class="cls-7"
                    x="1290.26"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-207"
                    class="cls-5"
                    x="1291.78"
                    y="723.21"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_419"
                    data-name="419"
                    class="cls-7"
                    x="1339.36"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-208"
                    class="cls-5"
                    x="1340.78"
                    y="723.21"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_418"
                    data-name="418"
                    class="cls-7"
                    x="1388.36"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-209"
                    class="cls-5"
                    x="1389.78"
                    y="723.21"
                    width="45.96"
                    height="22.76"
                />
                <rect
                    id="_417"
                    data-name="417"
                    class="cls-7"
                    x="1437.46"
                    y="658.77"
                    width="45.7"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-210"
                    class="cls-5"
                    x="1439.13"
                    y="723.21"
                    width="42.36"
                    height="22.76"
                />
                <rect
                    id="_416"
                    data-name="416"
                    class="cls-7"
                    x="1483.16"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-211"
                    class="cls-5"
                    x="1484.93"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_415"
                    data-name="415"
                    class="cls-7"
                    x="1532.26"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-212"
                    class="cls-5"
                    x="1533.93"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_414"
                    data-name="414"
                    class="cls-7"
                    x="1581.26"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-213"
                    class="cls-5"
                    x="1582.93"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_413"
                    data-name="413"
                    class="cls-7"
                    x="1630.36"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-214"
                    class="cls-5"
                    x="1631.93"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_412"
                    data-name="412"
                    class="cls-7"
                    x="1679.36"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-215"
                    class="cls-5"
                    x="1680.93"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_411"
                    data-name="411"
                    class="cls-7"
                    x="1728.36"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-216"
                    class="cls-5"
                    x="1729.93"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_410"
                    data-name="410"
                    class="cls-7"
                    x="1777.46"
                    y="658.77"
                    width="52.2"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-217"
                    class="cls-5"
                    x="1778.93"
                    y="723.21"
                    width="49.06"
                    height="22.76"
                />
                <rect
                    id="_409"
                    data-name="409"
                    class="cls-7"
                    x="1829.76"
                    y="658.77"
                    width="55.4"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-218"
                    class="cls-5"
                    x="1831.43"
                    y="723.21"
                    width="52.06"
                    height="22.76"
                />
                <rect
                    id="_408"
                    data-name="408"
                    class="cls-7"
                    x="1885.26"
                    y="658.77"
                    width="55.4"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-219"
                    class="cls-5"
                    x="1886.93"
                    y="723.21"
                    width="52.06"
                    height="22.76"
                />
                <rect
                    id="_407"
                    data-name="407"
                    class="cls-7"
                    x="1940.66"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-220"
                    class="cls-5"
                    x="1942.33"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
                <rect
                    id="_406"
                    data-name="406"
                    class="cls-7"
                    x="1989.66"
                    y="658.77"
                    width="49"
                    height="87.2"
                />
                <rect
                    style="display: none"
                    id="rendszam-221"
                    class="cls-5"
                    x="1991.33"
                    y="723.21"
                    width="45.66"
                    height="22.76"
                />
            </g>
            <path
                id="oszlopok"
                class="cls-8"
                d="M2176.66,838h35v35h-35Zm-4.8-111.5h35v-35h-35Zm-3.2-144.1h35v-35h-35Zm-6.4-148.6h35v-35h-35Zm-2.7-96.3h35v-34.9h-35Zm30.4-171.1h-35v34.9h35Zm-151.3,0h-35v34.9h35Zm-98,0h-35v34.9h35Zm-145.7,0h-35v34.9h35Zm-98.1,0h-35v34.9h35Zm-196.9,0h-35v34.9h35Zm-143.2,0h-34.9v34.9h34.9Zm-98,0h-34.9v34.9h34.9Zm-147,0h-34.9v34.9h34.9Zm-97.2,0h-34.9v34.9h34.9Zm-145.3,0h-34.9v34.9h34.9Zm-198.6,0h-34.9v34.9h34.9Zm-98,0h-34.9v34.9h34.9Zm-143.8,0H394v34.9h34.9Zm-101.2,0h-34.9v34.9h34.9Zm-142.8,35v-34.9H150v34.9Zm-30.1,155.7h34.9v-34.9h-34.9Zm12.7,244.5h34.9v-35h-34.9Zm9.7,289.4h34.9v-34.9h-34.9Zm148.4,141.2h34.9v-35h-34.9Zm100.1-3.2h35v-34.9h-35Zm-4.9-146.9h34.9v-35h-34.9Zm217.8,0h34.9v-35h-34.9Zm0-292.3h34.9v-35h-34.9Zm0,146.2h34.9V701h-34.9Zm-65.9-181.1h-34.9v35h34.9Zm0,146.1h-34.9v35h34.9Zm-156.8-111.2h34.9v-35h-34.9Zm35,111.2H416v35h34.9Zm-137.5-111.2h34.9v-35h-34.9Zm35,111.2h-34.9v35h34.9Zm486.3,181.1h34.9v-35h-34.9Zm245.9,0h34.9v-35h-34.9Zm-99.1,0h34.9v-35h-34.9ZM834.66,736h34.9V701h-34.9Zm245.9,0h34.9V701h-34.9Zm-99.1,0h34.9V701h-34.9Zm-146.8-146.2h34.9v-35h-34.9Zm0-146.2h34.9v-34.9h-34.9Zm0-96.3h34.9v-34.9h-34.9Zm-164,61.4h-34.9v34.9h34.9Zm0-96.3h-34.9v34.9h34.9Zm-125.2,131.2h27.2v-34.9h-27.2Zm0-96.3h27.2v-34.9h-27.2Zm535.1,242.5h34.9v-35h-34.9Zm-99.1,0h34.9v-35h-34.9ZM638.56,1029h34.9v-34.9h-34.9Zm196.1,0h34.9v-34.9h-34.9Zm245.9,0h34.9v-34.9h-34.9Zm144.6-146.9h34.9v-35h-34.9Zm0-292.3h34.9v-35h-34.9Zm0,439.2h34.9v-34.9h-34.9Zm96.9-146.9H1357v-35h-34.9Zm342.1,0h35v-35h-35Zm267.9,0h35v-35h-35Zm-610,146.9H1357v-34.9h-34.9Zm143.6-146.9h35v-35h-35Zm-143.6-292.3H1357v-35h-34.9Zm143.6,0h35v-35h-35ZM1225.16,736h34.9V701h-34.9Zm96.9,0H1357V701h-34.9Zm143.6,0h35V701h-35Zm377.9,111.2h-35v35h35Zm188.5,34.9h35v-35h-35ZM2021.26,586h35V551h-35ZM1795,554.87h-35v35h35Zm128.2,34.9h35v-35h-35Zm-259,0h35v-35h-35ZM1322.06,444H1357V409h-34.9Zm143.6,0h35V409h-35Zm198.5,0h35V409h-35Zm-342.1-96.7H1357v-34.9h-34.9Zm143.6,0h35v-34.9h-35Zm198.5,0h35v-34.9h-35ZM1795,409h-35v35h35Zm0-96.6h-35v34.9h35Zm137.1,716.6h35v-34.9h-35Zm100,0h35v-34.9h-35Zm-566.4,0h35v-34.9h-35Zm-484.2,0h34.9v-34.9h-34.9Zm-821.8-574.3h34.9v-35h-34.9Zm12.6,293.8h35v-35h-34.9v35Zm8.9,288.8h34.9v-34.9h-34.9Zm137-150.3h34.9v-34.9h-34.9Zm207.7-39.8H491v35h34.9Zm0,146.8H491v34.9h34.9Zm1655.6,25.4h35v-35h-35Z"
            />
            <path
                id="line_grid"
                data-name="line grid"
                class="cls-5"
                d="M66.63,90.7H89.36V94H70.09l.64,19.27-3.34.12Zm26.43,0h42V94H115.73v19.33h-3.34V94H93.06Zm52.3,0h42V94H168v19.33h-3.34V94H145.36Zm45.8,0h42V94H213.83v19.33h-3.34V94H191.16Zm49,0h42V94H262.83v19.33h-3.34V94H240.16Zm49,0h42V94H311.83v19.33h-3.34V94H289.16Zm49,0h42V94H360.83v19.33h-3.34V94H338.16Zm52.2,0h42V94H413v19.33h-3.34V94H390.36Zm45.8,0h42V94H458.83v19.33h-3.34V94H436.16Zm49,0h42V94H507.83v19.33h-3.34V94H485.16Zm49,0h42V94H556.83v19.33h-3.34V94H534.16Zm49,0h42V94H605.83v19.33h-3.34V94H583.16Zm49,0h42V94H654.83v19.33h-3.34V94H632.16Zm49,0h42V94H703.83v19.33h-3.34V94H681.16Zm52.3,0h42V94H756.13v19.33h-3.34V94H733.46Zm45.8,0h42V94H801.93v19.33h-3.34V94H779.26Zm49,0h42V94H850.93v19.33h-3.34V94H828.26Zm49,0h42V94H899.93v19.33h-3.34V94H877.26Zm49,0h42V94H948.93v19.33h-3.34V94H926.26Zm49,0h42V94H997.93v19.33h-3.34V94H975.26Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49.1,0h42V94H1243v19.33h-3.34V94h-19.33Zm49,0h42V94H1292v19.33h-3.34V94h-19.33Zm49,0h42V94H1341v19.33h-3.34V94h-19.33Zm45.7,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49.1,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49.1,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm45.7,0h42V94h-19.33v19.33h-3.37V94H1998Zm55.5,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm49,0h42V94h-19.33v19.33h-3.34V94h-19.33Zm42.6,0h22.62l.75,22.61-3.34.12L2262.44,94h-19.38ZM72.53,168.21l.65,19.39H92.56v3.34H69.94l-.75-22.61Zm2195.7,0,.76,22.73h-22.73V187.6h19.27l-.64-19.27Zm-2155.84.06h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm52.3,0H168V187.6h19.33v3.34h-42V187.6h19.33Zm45.8,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm52.2,0H413V187.6h19.33v3.34h-42V187.6h19.33Zm45.8,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm52.3,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm45.8,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49.1,0H1243V187.6h19.33v3.34h-42V187.6h19.33Zm49,0H1292V187.6h19.33v3.34h-42V187.6h19.33Zm49,0H1341V187.6h19.33v3.34h-42V187.6h19.33Zm45.7,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49.1,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49.1,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm45.7,0h3.34V187.6H2040v3.34h-42V187.6h19.3Zm55.5,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33Zm49,0h3.34V187.6h19.33v3.34h-42V187.6h19.33ZM1841.89,285.2h22.67v3.34h-19.3v19.33h-3.34Zm30.17,0h22.67v22.67h-3.34V288.54h-19.33Zm-1219,4h22.7v3.34H656.43v19.33h-3.34Zm29.47,0h42v3.34H705.26v19.33h-3.34V292.54H682.56Zm48.7,0h42v3.34h-19.3v19.33h-3.34V292.54H731.26Zm48.8,0h42v3.34h-19.3v19.33h-3.34V292.54H780.06Zm48.8,0h42v3.34h-19.3v19.33h-3.34V292.54H828.86Zm48.7,0h42v3.34H900.26v19.33h-3.34V292.54H877.56Zm48.8,0h42v3.34H949v19.33h-3.34V292.54h-19.3Zm50.6,0h42.6v3.34h-19.27v19.33h-4V292.54H977Zm46.2,0h22.67v22.67h-3.34V292.54h-19.3Zm271.13,0h22.67v3.34H1297.6v19.33h-3.34Zm24.07,0h42v3.34H1341v19.33h-3.34V292.54h-19.3Zm46.6,0h42v3.34H1387.6v19.33h-3.34V292.54H1365Zm49.9,0h42v3.34H1437.5v19.33h-3.34V292.54h-19.3Zm46.6,0h42v3.34H1484.1v19.33h-3.34V292.54h-19.3Zm46.7,0H1550v3.34H1530.8v19.33h-3.44V292.54h-19.2Zm49.8,0h42v3.34H1580.6v19.33h-3.34V292.54H1558Zm49.9,0h42v3.34H1630.5v19.33h-3.34V292.54h-19.3Zm49.9,0h22.67v22.67h-3.34V292.54h-19.3ZM485.66,294.9h22.7v3.34H489v19.33h-3.34Zm35.57,0H543.9v22.67h-3.34V298.24h-19.3Zm1598.43,23.4h22.67v3.34H2123V341h-3.34Zm39.07,0h42v3.34H2181.4V341h-3.34V321.64h-19.3Zm47.9,0h42v3.34h-19.37V341h-3.34V321.64h-19.3Zm45.2,0h22.67V341h-3.34V321.64h-19.3ZM78.49,336.6h22.67v3.34H81.83v19.33H78.49Zm27.17,0h42v3.34H128.33v19.33H125V339.94H105.66Zm46.6,0h41.9v3.34H174.93v19.33h-3.44V339.94H152.26Zm61.6,0h22.67v22.67h-3.34V339.94H213.86Zm1628,10.47h3.4V366.4h19.33v3.37h-22.67Zm49.5,0h3.34v22.7h-22.64v-3.34h19.33Zm-1405.7.3H489V366.7h19.36V370H485.69Zm54.9,0h3.34V370H521.26V366.7h19.33Zm405.1.4H949V367.1h19.33v3.34H949v27h-3.34v-19.3h-19.3v-3.37h19.33Zm50.6,0h4V367.1h19.33v3.34H977V367.1h19.27Zm46.2,0h3.34v22.67h-22.64V367.1h19.33Zm251.8,7.5h3.34V374.6h19.33v3.34H1297.6v19.33h-3.34Zm43.4,0H1341V374.6h19.33v3.34H1341v19.33h-3.34V377.94h-19.3V374.6h19.33Zm46.6,0h3.34V374.6h19.33v3.34H1387.6v19.33h-3.34V377.94H1365V374.6h19.3Zm49.9,0h3.34V374.6h19.33v3.34H1437.5v19.33h-3.34V377.94h-19.3V374.6h19.33Zm46.6,0h3.34V374.6h19.33v3.34H1484.1v19.33h-3.34V377.94h-19.3V374.6h19.33Zm46.6,0h3.44V374.6H1550v3.34H1530.8v19.33h-3.44V377.94h-19.2V374.6h19.23Zm49.9,0h3.34V374.6h19.33v3.34H1580.6v19.33h-3.34V377.94H1558V374.6h19.3Zm49.9,0h3.34V374.6h19.33v3.34H1630.5v19.33h-3.34V377.94h-19.3V374.6h19.33Zm49.9,0h3.34v42h-3.34V377.94h-19.3V374.6h19.33Zm-1024,.2h3.34v19.3h19.36v3.34H656.43v19.36h-3.34Zm48.8,0h3.4v19.3h19.3v3.34h-19.3v19.36h-3.34V378.14H682.56v-3.37h19.33Zm48.7,0h3.34v19.3h19.36v3.34H753.93v19.36h-3.34V378.14H731.26v-3.37h19.33Zm48.8,0h3.34v19.3h19.36v3.34H802.73v19.36h-3.34V378.14H780.06v-3.37h19.33Zm48.8,0h3.34v19.3h19.36v3.34H851.53v19.36h-3.34V378.14H828.86v-3.37h19.33Zm48.7,0h3.4v19.3h19.33v3.34H900.26v19.36h-3.34V378.14H877.56v-3.37h19.33Zm1222.8,39.8H2123V414.6h19.33v3.34h-22.67Zm58.4,0h3.34V414.6h19.33v3.34h-19.27l.64,19.27-3.34.12-.65-19.39h-19.35V414.6h19.33Zm47.9,0h3.3V414.6h19.33v3.34h-42V414.6h19.33Zm45.2,0h3.34v21l.7,21-3.34.12-.65-19.39h-19.35v-3.34h19.33ZM78.49,415.17h3.34V434.5h19.33v3.34H81.89l.74,19.27-3.34.12-.74-19.39h-.06V436.2l-.06-1.7h.06Zm46.5,0h3.34V434.5h19.33v3.34h-42V434.5H125Zm46.5,0h3.44V434.5h19.23v3.34H175l.64,19.27-3.34.12-.65-19.39H152.26V434.5h19.23Zm61.7,0h3.34v22.67H213.86V434.5h19.33ZM2182.33,444l.65,19.39h19.38v3.37h-19.27l.64,19.27-3.34.12-1.4-42Zm93.1,0,1.4,42-3.34.12-.65-19.39h-19.38V463.4h19.27l-.64-19.27Zm-1622.34.56h3.34V463.9h19.33v3.34H653.09Zm48.8,0h3.37V463.9h19.3v3.34h-42V463.9h19.33Zm48.7,0h3.34V463.9h19.33v3.34h-42V463.9h19.33Zm48.8,0h3.34V463.9h19.33v3.34h-42V463.9h19.33Zm48.8,0h3.34V463.9h19.33v3.34h-42V463.9h19.33Zm48.7,0h3.37V463.9h19.33v3.34h-42V463.9h19.33Zm48.8,0H949v22.67H926.36V463.9h19.33Zm348.6,0h3.34V463.9H1317v3.34h-22.7Zm43.4,0H1341V463.9h19.33v3.34h-42V463.9h19.33Zm46.6,0h3.34V463.9H1407v3.34h-42V463.9h19.3Zm49.9,0h3.34V463.9h19.33v3.34h-42V463.9h19.33Zm46.6,0h3.34V463.9h19.33v3.34h-42V463.9h19.33Zm46.6,0h3.44V463.9h19.23v3.34h-41.9V463.9h19.23Zm49.9,0h3.34V463.9H1600v3.34h-42V463.9h19.3Zm49.9,0h3.34V463.9h19.33v3.34h-42V463.9h19.33Zm49.9,0h3.34v22.67h-22.67V463.9h19.33ZM175.93,466.71l1.4,42-3.34.12-.65-19.38-19.37.09V486.2l19.28-.09-.64-19.28ZM83,467l.74,19.38,19.38-.09v.1h.1v3.37L84,489.86l.74,19.28-3.34.12-.72-19.49h-.1l-.86-22.62Zm2100.9,25.76.65,19.39H2204v3.34h-19.27l.64,19.27-3.34.12-1.4-42Zm93.1,0,1.4,42-3.34.12-.65-19.39h-19.38v-3.34h19.27l-.64-19.27ZM177.53,518l1.4,41.9-3.34.12L175,540.77l-19.38.09v-3.44l19.28-.09-.59-19.18Zm-92.4.5.73,19.3,19.39-.09v3.44L86,541.21l.82,19.17-3.34.14-1-22.73h0l-.73-19.18Zm2100.4,23.1.65,19.39h19.38v3.34h-19.3l.64,19.27-3.34.12-1.4-42Zm93.1,0,.76,22.73h-.1l.64,19.27-3.34.12-.65-19.39h-19.38V561h19.37l-.67-19.19ZM179.13,566l1.4,42-3.34.12-.64-19.32-19.37.18v-3.34l19.29-.18-.64-19.29Zm-92,.79L88,586.14l19.38-.18v3.34l-19.28.18.83,19.28-3.34.14-1.8-42ZM331.59,570h22.67v3.34H334.93v19.37h-3.34Zm30.67,0h41.3v3.34H384.93v19.37h-4V573.34H362.26Zm49.3,0h41.3v3.34h-18.6v19.37h-4V573.34h-18.7Zm62.2,0H515v3.34H496.43v19.37h-4.17V573.34h-18.5Zm62.2,0h41.2v3.34H558.63v19.37h-4.14V573.34H536Zm49.2,0h41.3v3.34H607.83v19.37h-4V573.34H585.16Zm49.3,0h41.3v3.34H657.13v19.37h-4V573.34H634.46Zm49.3,0H725v3.34H706.43v19.37h-4.17V573.34h-18.5Zm49.2,0h41.3v3.34H755.63v19.37h-4V573.34H733Zm49.3,0h41.3v3.34H804.93v19.37h-4V573.34H782.26Zm49.3,0h41.3v3.34h-18.6v19.37h-4V573.34h-18.7Zm46,0h41.3v3.34h-18.6v19.37h-4V573.34h-18.7Zm49.3,0h41.3v3.34H949.53v19.37h-4V573.34H926.86Zm49.2,0h41.3v3.34H998.73v19.37h-4V573.34H976.06Zm49.3,0h41.3v3.34H1048v19.37h-4V573.34h-18.67Zm49.3,0h22.67v22.71H1094V573.34h-19.33Zm165,0h22.67v3.34H1243v19.37h-3.34Zm29.57,0h42.1v3.34H1292v19.37h-3.44V573.34h-19.3Zm49,0h42.1v3.34H1341v19.37h-3.44V573.34h-19.3Zm49.1,0h42.1v3.34H1390.1v19.37h-3.44V573.34h-19.3Zm49,0h42.1v3.34H1439.1v19.37h-3.44V573.34h-19.3Zm45.8,0h42.13v3.34h-19.33v19.37h-3.44V573.34h-19.33Zm49.1,0h42v3.34H1533.9v19.37h-3.34V573.34h-19.3Zm49,0h42.1v3.34H1583v19.37h-3.44V573.34h-19.3Zm49,0h42.1v3.34H1632v19.37h-3.44V573.34h-19.3Zm49,0h42.1v3.34H1681v19.37h-3.44V573.34h-19.3Zm49.1,0h42.1v3.34H1730.1v19.37h-3.44V573.34h-19.3Zm49,0h42.1v3.34H1779.1v19.37h-3.44V573.34h-19.3Zm52.3,0h42.1v3.34H1831.4v19.37H1828V573.34h-19.3Zm55.5,0h42.13v3.34h-19.33v19.37h-3.44V573.34h-19.33Zm55.5,0h42v3.34h-19.37v19.37h-3.34V573.34h-19.3Zm49,0h42.1v3.34H1991.4v19.37H1988V573.34h-19.3Zm49,0h22.63v22.71h-3.34V573.34h-19.3Zm169.47,20.41.65,19.39h19.38v3.34h-19.27l.64,19.27-3.34.12-1.4-42Zm93.1,0,.76,22.73h-.1l.64,19.27-3.34.12-.65-19.39h-19.35v-3.33h19.37l-.64-19.27ZM180.7,613l1.4,42-3.34.12-.62-19.32-19.36.18v-3.34l19.29-.18-.64-19.29Zm-91.6,1,.82,19.28,19.39-.18v3.34h0v.1L90,636.69l.82,19.18-3.34.14-1.8-41.9Zm242.49,23.9h3.34V657.2h19.33v3.34H334.93v19.33h-3.34Zm49.3,0h4V657.2h18.67v3.34H384.93v19.33h-4V660.54H362.26V657.2h18.63Zm49.3,0h4V657.2h18.67v3.34h-18.6v19.33h-4V660.54h-18.7V657.2h18.63Zm62.1,0h4.14V657.2H515v3.34H496.43v19.33h-4.17V660.54h-18.5V657.2h18.5Zm62.2,0h4.14V657.2h18.53v3.34H558.63v19.33h-4.14V660.54H536V657.2h18.53Zm49.3,0h4V657.2h18.67v3.34H607.83v19.33h-4V660.54H585.16V657.2h18.63Zm49.3,0h4V657.2h18.67v3.34H657.13v19.33h-4V660.54H634.46V657.2h18.63Zm49.2,0h4.14V657.2H725v3.34H706.43v19.33h-4.17V660.54h-18.5V657.2h18.5Zm49.3,0h4V657.2h18.67v3.34H755.63v19.33h-4V660.54H733V657.2h18.63Zm49.3,0h4V657.2h18.67v3.34H804.93v19.33h-4V660.54H782.26V657.2h18.63Zm49.3,0h4V657.2h18.67v3.34h-18.6v19.33h-4V660.54h-18.7V657.2h18.63Zm46,0h4V657.2h18.63v3.34H900.26v19.33h-4V660.54h-18.7V657.2h18.63Zm49.3,0h4V657.2h18.63v3.34H949.49v19.33h-4V660.54H926.86V657.2h18.63Zm49.2,0h4V657.2h18.63v3.34H998.69v19.33h-4V660.54H976.06V657.2h18.63Zm49.3,0h4V657.2h18.63v3.34H1048v19.33h-4V660.54h-18.63V657.2H1044Zm50,0h3.34v42H1094V660.54h-19.33V657.2H1094Zm145.7,0H1243V657.2h19.33v3.34H1243v19.33h-3.34Zm48.9,0H1292V657.2h19.33v3.34H1292v19.33h-3.44V660.54h-19.33V657.2h19.33Zm49,0H1341V657.2h19.33v3.34H1341v19.33h-3.44V660.54h-19.33V657.2h19.33Zm49.1,0h3.44V657.2h19.33v3.34h-19.33v19.33h-3.44V660.54h-19.33V657.2h19.33Zm49,0h3.44V657.2h19.33v3.34h-19.33v19.33h-3.44V660.54h-19.33V657.2h19.33Zm45.8,0h3.44V657.2h19.33v3.34h-19.33v19.33h-3.44V660.54h-19.33V657.2h19.33Zm49.1,0h3.34V657.2h19.33v3.34h-19.33v19.33h-3.44V660.54h-19.33V657.2h19.43Zm49,0H1583V657.2h19.33v3.34h-19.43v19.33h-3.34V660.54h-19.33V657.2h19.33Zm49,0H1632V657.2h19.33v3.34H1632v19.33h-3.44V660.54h-19.33V657.2h19.33Zm49,0H1681V657.2h19.33v3.34H1681v19.33h-3.34V660.54h-19.43V657.2h19.33Zm49.1,0h3.44V657.2h19.33v3.34h-19.33v19.33h-3.44V660.54h-19.33V657.2h19.33Zm49,0h3.44V657.2h19.33v3.34h-19.33v19.33h-3.44V660.54h-19.33V657.2h19.33Zm52.3,0h3.44V657.2h19.33v3.34h-19.33v19.33H1828V660.54h-19.33V657.2H1828Zm55.5,0h3.44V657.2h19.33v3.34h-19.43v19.33h-3.34V660.54h-19.33V657.2h19.33Zm55.5,0h3.34V657.2h19.33v3.34h-19.33v19.33H1939V660.54h-19.33V657.2H1939Zm49,0h3.44V657.2h19.33v3.34h-19.33v19.33H1988V660.54h-19.33V657.2H1988Zm49,0h3.34v42H2037V660.54h-19.33V657.2H2037Zm151.74,1.34.65,19.39h19.38v3.34h-19.27l.64,19.27-3.34.12-1.4-42Zm93.1,0,.76,22.73h-.1l.64,19.27-3.34.12-.65-19.39h-19.38V658.6h19.37l-.64-19.27Zm-2099.5,19.4.76,22.71H183l.64,19.29-3.37.16-.64-19.37-19.27.28h-.09v-3.34l19.39-.28L179,658.77Zm-91.2,1.29L92,679.28l19.38-.28v3.34l-19.29.28.74,19.29-3.34.12-.8-21-.9-21ZM2190.33,688l.65,19.39h19.38v3.37h-19.27l.64,19.27-3.34.12-1.4-42Zm93,0,1.4,42-3.34.12-.65-19.39h-19.38V707.4h19.27l-.64-19.27Zm-2099.5,19.9,1.4,42-3.34.12-.63-19.37-19.37.28V727.6l19.29-.28L180.54,708Zm-90.7,1.5.73,19.27,19.48-.28v3.37h-.08v.1l-19.18.27.73,19.2-3.34.12-.73-19.27h-.11l-.86-22.63ZM331.59,725h3.34V744.3h19.33v3.34H331.59Zm49.3,0h4V744.3h18.67v3.34h-41.3V744.3h18.63Zm49.3,0h4V744.3h18.67v3.34h-41.3V744.3h18.63Zm62.1,0h4.14V744.3H515v3.34h-41.2V744.3h18.5Zm62.2,0h4.14V744.3h18.53v3.34H536V744.3h18.53Zm49.3,0h4V744.3h18.67v3.34h-41.3V744.3h18.63Zm49.3,0h4V744.3h18.67v3.34h-41.3V744.3h18.63Zm49.2,0h4.14V744.3H725v3.34h-41.2V744.3h18.5Zm49.3,0h4V744.3h18.67v3.34H733V744.3h18.63Zm49.3,0h4V744.3h18.67v3.34h-41.3V744.3h18.63Zm49.3,0h4V744.3h18.67v3.34h-41.3V744.3h18.63Zm46,0h4V744.3h18.63v3.34H877.56V744.3h18.63Zm49.3,0h4V744.3h18.63v3.34h-41.3V744.3h18.63Zm49.2,0h4V744.3h18.63v3.34H976V744.3h18.63Zm49.3,0h4V744.3h18.63v3.34h-41.3V744.3H1044Zm50,0h3.34v22.67h-22.67V744.3H1094Zm145.7,0H1243V744.3h19.33v3.34h-22.67Zm48.9,0H1292V744.3h19.33v3.34h-42.1V744.3h19.33Zm49,0H1341V744.3h19.33v3.34h-42.1V744.3h19.33Zm49.1,0h3.44V744.3h19.33v3.34h-42.1V744.3h19.33Zm49,0h3.44V744.3h19.33v3.34h-42.1V744.3h19.33Zm45.8,0h3.44V744.3h19.33v3.34h-42.1V744.3h19.33Zm49,0h3.44V744.3h19.33v3.34h-42.1V744.3h19.33Zm49.1,0h3.34V744.3h19.33v3.34h-42V744.3h19.33Zm49,0H1632V744.3h19.33v3.34h-42.1V744.3h19.33Zm49.1,0H1681V744.3h19.33v3.34h-42V744.3h19.33Zm49,0h3.44V744.3h19.33v3.34h-42.1V744.3h19.33Zm49,0h3.44V744.3h19.33v3.34h-42.1V744.3h19.33Zm52.3,0h3.44V744.3h19.33v3.34h-42.1V744.3H1828Zm55.5,0h3.34V744.3h19.33v3.34h-42V744.3h19.33Zm55.5,0h3.34V744.3h19.33v3.34h-42V744.3H1939Zm49,0h3.44V744.3h19.33v3.34h-42.1V744.3H1988Zm49,0h3.34v22.67h-22.67V744.3H2037Zm154.94,11.8.65,19.39H2212v3.34h-19.27l.64,19.27-3.34.12-1.4-42Zm93,0,1.4,42-3.34.12-.65-19.39H2263v-3.34h19.3l-.64-19.27Zm-2099.6,19.9,1.4,42-3.34.12-.64-19.36-19.36.37-.06-3.34,19.3-.37-.64-19.3Zm-90.2,1.8.74,19.36,19.36-.37,0,3.31-19.3.37.74,19.3-3.34.12-1.6-42Zm2098.4,27.1.65,19.39h19.38v3.34h-19.3l.64,19.27-3.34.12-1.4-42Zm93,0,1.4,42-3.34.12-.65-19.39h-19.38V805h19.27l-.64-19.27Zm-2099.6,19.5.76,22.69h-.1l.64,19.31-3.34.12-.64-19.35L165,828.3h-.1l-.08-3.34,19.41-.46-.64-19.31Zm-89.8,2,.74,19.35,19.35-.46.08,3.34L98,829.76l.74,19.31-3.34.12-1.6-42Zm2098,27.3.65,19.39h19.38v3.34h-19.27l.64,19.27-3.34.12-1.4-42Zm93,0,1.4,42-3.34.12-.65-19.39h-19.38v-3.33h19.27l-.64-19.27Zm-2099.7,18.7.76,22.69h-.1l.64,19.31-3.34.12-.64-19.35-19.25.46h-.1l-.08-3.34,19.41-.46-.64-19.31ZM99,855.27l.73,19.25,19.36-.46.08,3.34h0v.1L99.9,878l.73,19.21-3.34.12-1.6-41.9Zm1140.66,5.59h22.67v3.34H1243v19.33h-3.34Zm29.47,0h41.2v3.34h-18.53v19.33h-4.14V864.2h-18.53Zm48,0h41.2v3.34h-18.53v19.33h-4.14V864.2h-18.53Zm48.1,0h41.1v3.34h-18.43v19.33h-4.24V864.2h-18.43Zm48,0h41.2v3.34h-18.53v19.33h-4.14V864.2h-18.53Zm48,0h41.2v3.34h-18.53v19.33h-4.14V864.2h-18.53Zm48,0h41.2v3.34h-18.53v19.33h-4.14V864.2h-18.53Zm48.1,0H1580v22.67h-3.34V864.2h-19.33Zm23.33,0h22.67v3.34H1584v19.33h-3.34Zm77.07,0h22.67v22.67h-3.34V864.2h-19.33Zm171,0h22.72v3.34H1832.2l.55,19.28-3.34.1Zm83.62,0H1935l.65,22.62-3.34.1-.55-19.38h-19.4Zm34.29,0h22.71v3.34h-19.29l.46,19.29-3.34.08Zm80.71,0H2050l.54,22.63-3.34.08-.46-19.37h-19.39Zm-1702.73,2.7h22.71v3.34H328.09l.64,19.27-3.34.12Zm82.83,0h42v3.34H430.13v19.33h-3.34V866.9H407.46Zm94.5,0h22.67v22.67h-3.39V866.9H502Zm152.63,0h22.65v3.34H657.93v19.33h-3.34Zm78.77,0h42v3.34H756v19.33h-3.34V866.9H733.36Zm48.5,0h42v3.34H804.53v19.33h-3.34V866.9H781.86Zm48.6,0h42v3.34H853.13v19.33h-3.34V866.9H830.46Zm48.5,0h42v3.34H901.65v19.33h-3.39V866.9H879Zm48.6,0h42v3.34H950.26v19.33h-3.34V866.9H927.56Zm48.5,0h42v3.34H998.75v19.33h-3.34V866.9H976.06Zm48.6,0h42v3.34h-19.33v19.33H1044V866.9h-19.35Zm50,0h22.67v22.67H1094V866.9h-19.35Zm1122.07,19.61.65,19.39h19.38v3.34h-19.27l.64,19.27-3.34.12-1.4-42Zm93,0,1.4,42-3.34.12-.65-19.39h-19.4v-3.34H2287l-.64-19.27Zm-1768.49,6.7h3.34V932h-3.34V912.69l-19.28.55-.1-3.34h0v-.1l19.38-.55ZM1950.6,890l.46,19.37h19.37v3.37H1951l.46,19.29-3.34.08-.54-22.71h.1l-.46-19.29Zm100,0,.54,22.71h-.1l.46,19.29-3.34.08-.46-19.37h-19.34V909.4h19.39l-.46-19.29Zm-217.7.29.55,19.38h19.38V913h-19.38l.55,19.28-3.34.1L1830,909.7h.1l-.55-19.28Zm102.8,0,1.2,42-3.34.1L1933,913h-19.35V909.7h19.28l-.55-19.28Zm-1281.14,1h3.34v19.33h19.36V914H657.93v19.33h-3.34Zm98.1,0H756v47.33h19.36V942H756v38.23h-3.34V960.89H733.36v-3.34h19.33V914H733.36v-3.34h19.33Zm-325.9,1.3h3.34V911.9l19.28-.55.1,3.34-19.38.55v19.38h-3.34V915.33l-19.29.46-.08-3.34,19.37-.46Zm1153.9.3H1584v19.33h19.33v3.34H1584v19.33h-3.34Zm96.4,0h3.34v42h-3.34V915.59h-19.3v-3.34h19.33Zm-1348,1.94.64,19.35,19.35-.46.08,3.34-19.31.46.74,19.31-3.34.12-.86-22.69h0L325.72,895Zm-139.2,5.8.75,22.68h0l.55,19.33-3.34.1-.55-19.33-19.33.55-.1-3.34,19.33-.55-.65-19.32Zm-89,2.4.74,19.34,19.34-.55.1,3.34-19.32.55.74,19.32-3.34.12-1.6-42Zm700.26,16.26h3.34v19.33h19.4V942h-42v-3.34h19.33Zm48.6,0h3.34v19.33h19.4V942h-42v-3.34h19.33Zm48.5,0h3.34v19.33h19.33V942h-42v-3.34h19.37Zm48.6,0h3.44v19.33h19.33V942h-42v-3.34h19.33Zm48.5,0h3.34v19.33H1018V942H976v-3.34h19.33Zm48.6,0h3.34v19.33h19.33V942h-42v-3.34h19.33Zm50,0h3.34V942h-22.6v-3.34H1094Zm145.7,3H1243v19.33h19.3V945h-22.67Zm48,0h4.14v19.33h18.5V945h-41.2v-3.34h18.53Zm48,0h4.14v19.33h18.5V945h-41.2v-3.34h18.53Zm48,0h4.24v19.33h18.4V945h-41v-3.34h18.43Zm48.1,0h4.14v19.33h18.53V945h-41.13v-3.34h18.53Zm48,0h4.14v19.33h18.53V945h-41.13v-3.34h18.53Zm48,0h4.14v19.33h18.53V945h-41.13v-3.34h18.53Zm48.9,0H1580V945h-22.6v-3.34h19.33Zm621.64,9.74.65,19.39h19.35v3.32h-19.37l.64,19.27-3.34.12-.76-22.73h.1l-.64-19.27Zm93,0,1.4,42-3.34.12-.65-19.39h-19.31v-3.34h19.27l-.64-19.27ZM654.59,938.17h3.34V957.5h19.33v3.34H657.93v19.33h-3.34Zm1297,.36.46,19.37h19.37v3.34h-19.29l.46,19.29-3.34.08-1-42Zm100,0,1,42-3.34.08-.46-19.37h-19.33V957.9h19.29l-.46-19.29Zm-217.4.49.55,19.38h19.38v3.37h-19.38l.55,19.28-3.34.1-.65-22.72h.1l-.55-19.28Zm102.8,0,1.2,42-3.34.1-.59-19.35H1915v-3.34h19.3l-.55-19.28Zm-1415.73.45h3.34v42h-3.34V962.16l-19.31.28V959.1l19.35-.28Zm-94.5,1.4h3.34v19.31l19.31-.28v3.34l-19.35.28v19.35h-3.34v-19.3l-19.3.37-.06-3.34,19.36-.38Zm-96,1.84.74,19.36,19.26-.37h.1l.06,3.34-19.4.37.64,19.3-3.34.12-.76-22.7h.1l-.74-19.3Zm1249.86,1.76H1584v19.3h19.3v3.34H1584v19.33h-3.34Zm96.4,0h3.34v42H1677V967.14h-19.26v-3.37h19.33ZM191.46,951.92l1.2,42-3.34.1-.55-19.33-19.33.55-.1-3.34,19.33-.55L188.12,952Zm-88.6,2.59.74,19.34,19.24-.55h.1l.1,3.34-19.42.55.74,19.32-3.34.12L100.16,974h.1l-.74-19.32Zm2097,26.3.65,19.39h19.38v3.34h-19.37l.74,19.23-3.34.12-.76-22.73h.1l-.64-19.27Zm93,0,1.4,42-3.34.12-.65-19.39H2271v-3.34h19.3l-.64-19.27ZM1952.66,987l.46,19.37h19.37v3.37H1953.1l.46,19.29-3.34.08-.54-22.71h.1l-.46-19.29Zm100,0,.6,22.74h-.1l.46,19.29-3.34.08-.46-19.37h-19.36v-3.34h19.39l-.46-19.29Zm-217.2.79.55,19.38h19.38v3.34H1836l.55,19.28-3.34.1-.65-22.72h.1l-.55-19.28Zm102.8,0,1.2,41.9-3.34.1-.55-19.28h-19.31v-3.44h19.28l-.55-19.18Zm-1283.74.55h3.34v19.33h19.4V1011H657.93v19.33h-3.34Zm98.1,0H756v42h-3.34V1011H733.36v-3.34h19.33Zm828,1.3H1584V1009h19.3v3.34H1584v19.33h-3.34Zm96.4,0h3.34v42H1677v-19.33h-19.26V1009h19.33Zm-1250.3,2.8h3.34v19.3h19.4v3.34H430.13v19.33h-3.34v-19.18l-19.28.55-.1-3.34h0v-.1l19.38-.6Zm94.5,0h3.34v42h-3.3v-19.33H502v-3.37h19.3Zm-188.56,2.84.64,19.24,19.34-.55.1,3.34h0v.1l-19.32.55.64,19.22-3.34.12-1.4-41.9Zm-139.8,6.21.55,19.33h.1l.65,22.68-3.34.1-.55-19.33L171,1025h-.1l-.12-3.34,19.34-.64-.55-19.34Zm-88.2,2.89.74,19.34,19.33-.65.12,3.34-19.33.64.74,19.33-3.34.12-1.6-42Zm2096.8,25.2.65,19.39h19.38v3.34h-19.37l.64,19.27-3.34.12-.76-22.73h.1l-.64-19.27Zm93,0,1.4,42-3.34.12-.65-19.39h-19.31V1049h19.27l-.64-19.27Zm-1639.87,5.76h3.34v19.33h19.33V1058H657.93v19.33h-3.34Zm98.1,0H756v42h-3.34V1058H733.36v-3.34h19.33Zm1201,.16.46,19.37h19.37v3.34h-19.39l.46,19.29-3.34.08-.54-22.71h.1l-.46-19.29Zm100,0,1,42-3.34.08-.46-19.37h-19.33v-3.34h19.29l-.46-19.29Zm-216.9,1,.55,19.38h19.38v3.34h-19.39l.46,19.29-3.34.08-.54-22.71h.09l-.55-19.28Zm102.8,0,.65,22.72h-.1l.55,19.28-3.34.1-.55-19.38h-19.34v-3.34h19.38l-.55-19.28Zm-1418.33,1.14h3.34v42h-3.34v-19.31l-19.31.18v-3.34l19.35-.18Zm-94.5,1h3.34V1058l19.31-.18v3.34l-19.35.18v19.35h-3.34v-19.28l-19.28.55-.1-3.34,19.38-.58Zm-92.5,2.64.64,19.34,19.34-.55.1,3.34L335,1064l.65,19.32-3.34.12-1.4-42Zm1246.36,3.26H1584v19.33h19.33v3.34H1584v19.33h-3.34Zm96.4,0h3.34v42H1677v-19.33h-19.3v-3.34h19.33Zm-1482.66,5,1.2,42-3.34.1-.55-19.33-19.32.65-.12-3.34,19.34-.64-.55-19.34Zm-87.8,3.09.73,19.24,19.34-.65.12,3.34h0v.1l-19.32.64.73,19.23-3.34.12-.73-19.24h0l-.83-22.67Zm2189.5,23.4.76,22.69-22.69.54-.08-3.34,19.31-.46-.64-19.31Zm-93,2.4.64,19.35,19.35-.46.08,3.34-22.65.54-.76-22.65Zm-1450.44.66H756v42h-3.3v-19.35l-19.27.64-.12-3.34,19.39-.65Zm-98.1,3.3h3.34v19.27l19.27-.64.12,3.34-19.39.65v19.38h-3.3Zm1400.14.06.54,22.69-22.69.32v-3.34l19.31-.28-.46-19.31Zm-100,1.6.46,19.35,19.35-.28v3.34l-22.65.32-.54-22.65Zm-13.8,1.29.65,22.7-22.7.32v-3.34l19.3-.28-.55-19.3Zm-1419.6.7h3.34V1128h-3.34v-19.2l-19.31.28v-3.34h0v-.1l19.35-.28Zm1316.84.86.46,19.35,19.35-.28v3.34l-22.65.32-.54-22.65Zm-1411.34.54h3.34v19.3l19.31-.28v3.34l-19.35.28v19.35h-3.34v-19.27l-19.27.64-.12-3.34,19.39-.68Zm-90.76,3,.64,19.34,19.33-.65h.1l.12,3.34-19.33.64.64,19.33-3.34.12-.64-19.34h-.1l-.76-22.66Zm1244.66,5.66H1584v19.33h19.33v3.31h-22.67Zm96.4,0h3.34v22.64h-22.64v-3.34h19.33Zm-1481.26.25.6,21,.7,21-3.34.12-.64-19.33-19.33.74-.12-3.34,19.34-.74-.55-19.34Zm-87.4,3.29.74,19.33,19.33-.74.12,3.34-19.33.73.74,19.34-3.34.12-1.6-42Zm644.26,23.16H756v22.62l-22.61.75-.12-3.34,19.39-.65Zm-98.1,3.2h3.34v19.27l19.27-.64.12,3.34-22.73.76ZM521.26,1131h3.34v22.62l-22.61.75-.12-3.34,19.39-.65Zm-94.5,3.1h3.34v19.27l19.27-.64.12,3.34-19.39.65v.11l-22.63.54-.08-3.34,19.37-.46Zm-89.06,2.24.64,19.35,19.35-.46.08,3.34-22.65.54-.76-22.65Zm-140.5,5.6.75,22.67-22.66.86-.12-3.34,19.34-.74-.65-19.33Zm-87,3.4.74,19.33,19.33-.74.12,3.34-22.67.86-.86-22.67Z"
            />
        </g>
    </svg>
</div>

<app-tooltip-garage-user
    *ngIf="isGarageUser"
    [tooltipData]="tooltipParkingSlotInfo"
    [floorNumber]="2">
</app-tooltip-garage-user>

<app-tooltip-garage-user-reservation
    *ngIf="isGarageUser"
    [tooltipData]="tooltip"
    [reservationStatus]="reservationStatus"
    [floorNumber]="1"
    (onTimeEnd)="updateCurrentReservationWithDelay()"
    (onExtendReservation)="extendReservation()">
</app-tooltip-garage-user-reservation>

<app-tooltip-admin
    *ngIf="isAdminOrReceptionist"
    [floorNumber]="2"
    [swapTooltip]="swapTooltip"
    [swapPlaceMode]="swapPlaceMode"
    (onSwap)="swapParkingSlot()"
    [tooltipData]="tooltip">
</app-tooltip-admin>

<div *ngIf="!isProduction && isGarageUser" class="emulate-gate">
    <div *ngIf="reservationStatus && reservationStatus.user">
        <a
            target="_blank"
            [attr.href]="
        backend_url +
        CONSTS.API_END_POINT.USER +
        '/' +
        reservationStatus.user.id +
        '/in-garage'
      "
        >
            <img src="/assets/images/temp_icon_IN.svg" alt="in"/>
        </a>
        <a
            target="_blank"
            [attr.href]="
        backend_url +
        CONSTS.API_END_POINT.USER +
        '/' +
        reservationStatus.user.id +
        '/leave'
      "
        >
            <img src="/assets/images/temp_icon_OUT.svg" alt="out"/>
        </a>
    </div>
</div>
